const actionsCsv = `Date,Open,High,Low,Close,Adj Close,Volume
2007-01-03,12.327143,12.368571,11.700000,11.971429,10.363638,309579900
2007-01-04,12.007143,12.278571,11.974286,12.237143,10.593664,211815100
2007-01-05,12.252857,12.314285,12.057143,12.150000,10.518225,208685400
2007-01-08,12.280000,12.361428,12.182858,12.210000,10.570165,199276700
2007-01-09,12.350000,13.282857,12.164286,13.224286,11.448232,837324600
2007-01-10,13.535714,13.971429,13.350000,13.857142,11.996092,738220000
2007-01-11,13.705714,13.825714,13.585714,13.685715,11.847687,360063200
2007-01-12,13.512857,13.580000,13.318571,13.517143,11.701755,328172600
2007-01-16,13.668571,13.892858,13.635715,13.871428,12.008460,311019100
2007-01-17,13.937143,13.942857,13.545714,13.564285,11.742566,411565000
2007-01-18,13.157143,13.158571,12.721429,12.724286,11.015380,591151400
2007-01-19,12.661428,12.807143,12.588572,12.642858,10.944892,341118400
2007-01-22,12.734285,12.737143,12.235714,12.398571,10.733409,363506500
2007-01-23,12.247143,12.501429,12.215714,12.242857,10.598609,301856100
2007-01-24,12.382857,12.450000,12.297143,12.385715,10.722281,231953400
2007-01-25,12.444285,12.642858,12.290000,12.321428,10.666628,226493400
2007-01-26,12.444285,12.481428,12.141429,12.197143,10.559033,246718500
2007-01-29,12.328571,12.378572,12.218572,12.277143,10.628289,225416100
2007-01-30,12.347143,12.355714,12.178572,12.221429,10.580058,144492600
2007-01-31,12.122857,12.285714,12.050000,12.247143,10.602318,214017300
2007-02-01,12.318571,12.324286,12.105714,12.105714,10.479885,166085500
2007-02-02,12.017143,12.178572,11.957143,12.107142,10.481125,155382500
2007-02-05,12.042857,12.175714,11.991428,11.991428,10.380950,144713100
2007-02-06,12.064285,12.067142,11.837143,12.021428,10.406919,216098400
2007-02-07,12.068571,12.340000,11.935715,12.307143,10.654263,266706300
2007-02-08,12.204286,12.358571,12.201428,12.311429,10.657969,169757700
2007-02-09,12.268572,12.314285,11.887143,11.895715,10.298089,215135200
2007-02-12,12.061429,12.168571,11.947143,12.125714,10.497200,181017900
2007-02-13,12.165714,12.184286,12.042857,12.100000,10.474938,145246500
2007-02-14,12.090000,12.234285,12.081429,12.185715,10.549142,126995400
2007-02-15,12.205714,12.231428,12.111428,12.172857,10.538010,90915300
2007-02-16,12.178572,12.201428,12.094286,12.118571,10.491017,99967000
2007-02-20,12.092857,12.308572,12.022857,12.271428,10.623343,154425600
2007-02-21,12.282857,12.784286,12.280000,12.742857,11.031457,288828400
2007-02-22,12.971429,12.972857,12.647142,12.787143,11.069796,209556200
2007-02-23,12.737143,12.905714,12.692857,12.724286,11.015380,129473400
2007-02-26,12.834286,12.857142,12.515715,12.644286,10.946124,153962200
2007-02-27,12.328571,12.440000,11.915714,11.990000,10.379711,286453300
2007-02-28,11.857142,12.228572,11.857142,12.087143,10.463806,229868800
2007-03-01,12.004286,12.615714,11.964286,12.437143,10.766805,353882200
2007-03-02,12.395715,12.505714,12.172857,12.201428,10.562744,215000100
2007-03-05,12.270000,12.664286,12.251429,12.331429,10.675284,209724900
2007-03-06,12.542857,12.615714,12.485714,12.598572,10.906552,180796700
2007-03-07,12.578571,12.710000,12.492857,12.531428,10.848425,156571100
2007-03-08,12.655714,12.674286,12.494286,12.571428,10.883054,127752800
2007-03-09,12.685715,12.692857,12.485714,12.567142,10.879340,112959000
2007-03-12,12.581429,12.855714,12.570000,12.838572,11.114322,182352100
2007-03-13,12.772857,12.942857,12.628572,12.628572,10.932521,216972700
2007-03-14,12.657143,12.857142,12.560000,12.857142,11.130396,199146500
2007-03-15,12.851429,12.908571,12.758572,12.795714,11.077216,139874700
2007-03-16,12.791429,12.855714,12.760000,12.798572,11.079692,142926000
2007-03-19,12.891429,13.078571,12.798572,13.018572,11.270142,178240300
2007-03-20,13.050000,13.120000,13.008572,13.068571,11.313428,122229100
2007-03-21,13.141429,13.428572,13.092857,13.410000,11.609003,171724000
2007-03-22,13.390000,13.480000,13.285714,13.422857,11.620132,140373100
2007-03-23,13.335714,13.438571,13.328571,13.360000,11.565719,112721000
2007-03-26,13.427143,13.700000,13.328571,13.692857,11.853871,216246800
2007-03-27,13.672857,13.832857,13.571428,13.637143,11.805639,233013200
2007-03-28,13.554286,13.628572,13.307143,13.320000,11.531088,235584300
2007-03-29,13.455714,13.455714,13.175714,13.392858,11.594164,181430900
2007-03-30,13.468572,13.525714,13.250000,13.272857,11.490277,150139500
2007-04-02,13.448571,13.464286,13.288571,13.378572,11.581794,125498100
2007-04-03,13.448571,13.604285,13.394286,13.500000,11.686915,145983600
2007-04-04,13.562857,13.591429,13.447143,13.467143,11.658471,119196000
2007-04-05,13.445714,13.525714,13.360000,13.525714,11.709176,88879000
2007-04-09,13.601429,13.614285,13.291429,13.378572,11.581794,103335400
2007-04-10,13.381429,13.465714,13.344286,13.464286,11.655998,88116700
2007-04-11,13.414286,13.421429,13.190000,13.227143,11.450703,137254600
2007-04-12,13.148571,13.187143,12.960000,13.170000,11.401234,164168900
2007-04-13,12.985714,13.057143,12.865714,12.891429,11.160077,179985400
2007-04-16,12.938571,13.071428,12.892858,13.061429,11.307242,152258400
2007-04-17,13.142858,13.185715,12.814285,12.907143,11.173679,187980100
2007-04-18,12.880000,12.978572,12.800000,12.914286,11.179863,116011000
2007-04-19,12.884286,13.035714,12.832857,12.895715,11.163787,106478400
2007-04-20,12.984285,13.025714,12.935715,12.995714,11.250358,130694900
2007-04-23,13.084286,13.400000,13.060000,13.358571,11.564479,195072500
2007-04-24,13.422857,13.770000,13.042857,13.320000,11.531088,263813200
2007-04-25,13.461429,13.628572,13.400000,13.621428,11.792037,296786000
2007-04-26,14.511429,14.642858,14.042857,14.120000,12.223647,434444500
2007-04-27,14.025714,14.278571,13.955714,14.274285,12.357213,174850900
2007-04-30,14.298572,14.428572,14.238571,14.257143,12.342370,154127400
2007-05-01,14.227143,14.335714,14.078571,14.210000,12.301558,133130900
2007-05-02,14.235714,14.362857,14.210000,14.341429,12.415339,126286300
2007-05-03,14.390000,14.492857,14.287143,14.342857,12.416573,144019400
2007-05-04,14.400000,14.514286,14.357142,14.401428,12.467281,95496800
2007-05-07,14.440000,14.907143,14.430000,14.845715,12.851895,215389300
2007-05-08,14.781428,15.021428,14.774285,15.008572,12.992883,195999300
2007-05-09,14.987143,15.280000,14.984285,15.268572,13.217961,179439400
2007-05-10,15.232857,15.548572,15.131429,15.334286,13.274851,299314400
2007-05-11,15.391429,15.590000,15.254286,15.534286,13.447992,163424100
2007-05-14,15.660000,15.714286,15.464286,15.622857,13.524669,162986600
2007-05-15,15.652857,15.742857,15.211429,15.360000,13.297113,238628600
2007-05-16,15.504286,15.547143,14.774285,15.334286,13.274851,281691900
2007-05-17,15.307143,15.695714,15.307143,15.634286,13.534562,183822800
2007-05-18,15.747143,15.805715,15.681429,15.717143,13.606292,155336300
2007-05-21,15.758572,16.064285,15.721429,15.997143,13.848684,159973100
2007-05-22,16.070000,16.250000,16.001429,16.219999,14.041611,143102400
2007-05-23,16.288572,16.428572,16.084286,16.127142,13.961223,227843700
2007-05-24,16.115715,16.351429,15.767143,15.812857,13.689149,221840500
2007-05-25,16.000000,16.254286,15.928572,16.231428,14.051504,158239900
2007-05-29,16.350000,16.408571,16.098572,16.335714,14.141785,161423500
2007-05-30,16.328571,16.982857,16.218571,16.967142,14.688411,369611200
2007-05-31,17.152857,17.452858,17.077143,17.312857,14.987696,324266600
2007-06-01,17.299999,17.312857,16.898571,16.914286,14.642652,221315500
2007-06-04,16.947144,17.389999,16.842857,17.332857,15.005010,221668300
2007-06-05,17.344286,17.527143,17.214285,17.524286,15.170731,230196400
2007-06-06,17.471428,17.721428,17.421429,17.662857,15.290688,278060300
2007-06-07,17.855715,18.230000,17.598572,17.724285,15.343866,478769900
2007-06-08,17.974285,17.975714,17.469999,17.784286,15.395814,310420600
2007-06-11,18.000000,18.021429,17.077143,17.170000,14.864027,468564600
2007-06-12,17.049999,17.387142,16.901428,17.197144,14.887520,356641600
2007-06-13,17.307142,17.312857,16.485714,16.785715,14.531350,430338300
2007-06-14,16.742857,17.064285,16.631428,16.964285,14.685935,243316500
2007-06-15,17.231428,17.238571,17.122858,17.214285,14.902363,202804700
2007-06-18,17.611429,17.882856,17.505714,17.870001,15.470016,227651200
2007-06-19,17.812857,17.858572,17.558571,17.665714,15.293161,235756500
2007-06-20,17.695715,17.808571,17.357143,17.364286,15.032218,224378000
2007-06-21,17.385714,17.755714,17.245714,17.700001,15.322845,216761300
2007-06-22,17.692858,17.778572,17.482857,17.571428,15.211541,157969000
2007-06-25,17.741428,17.870001,17.294285,17.477142,15.129917,241350900
2007-06-26,17.711428,17.714285,16.959999,17.092857,14.797243,336251300
2007-06-27,17.230000,17.434286,17.037144,17.412857,15.074263,243674200
2007-06-28,17.480000,17.498571,17.142857,17.222857,14.909783,209535900
2007-06-29,17.424286,17.714285,17.298571,17.434286,15.092814,284460400
2007-07-02,17.292856,17.441429,17.042856,17.322857,14.996350,248715600
2007-07-03,17.428572,18.200001,17.357143,18.167143,15.727248,290620400
2007-07-05,18.400000,18.995714,18.384285,18.964285,16.417334,363262900
2007-07-06,19.018572,19.048571,18.628571,18.900000,16.361683,218673700
2007-07-09,18.911428,18.985714,18.454287,18.618572,16.118048,248955000
2007-07-10,18.411428,19.214285,18.401428,18.907143,16.367863,313751900
2007-07-11,18.867144,19.100000,18.758572,18.912857,16.372807,205443000
2007-07-12,19.121429,19.177143,18.912857,19.152857,16.580580,176152200
2007-07-13,19.290001,19.692858,19.217142,19.675714,17.033209,226901500
2007-07-16,19.770000,19.997143,19.642857,19.728571,17.078968,234028200
2007-07-17,19.757143,19.942858,19.642857,19.844286,17.179150,177489900
2007-07-18,19.741428,19.777143,19.434286,19.731428,17.081448,189214200
2007-07-19,20.042856,20.115715,19.950001,20.000000,17.313948,183222900
2007-07-20,20.235714,20.597143,20.000000,20.535715,17.777714,291943400
2007-07-23,20.472857,20.745714,20.132856,20.528572,17.771532,259122500
2007-07-24,19.840000,20.142857,19.164286,19.270000,16.681984,448823200
2007-07-25,19.621429,19.765715,19.285715,19.608572,16.975092,374045700
2007-07-26,20.844286,21.214285,19.565714,20.857143,18.055975,546657300
2007-07-27,20.884285,21.274286,20.540001,20.549999,17.790079,290274600
2007-07-30,20.618572,20.778572,19.938572,20.204287,17.490799,276747100
2007-07-31,20.424286,20.497143,18.788572,18.822857,16.294901,440598200
2007-08-01,19.091429,19.340000,18.252857,19.285715,16.695593,437539200
2007-08-02,19.521429,19.565714,19.164286,19.498571,16.879862,213161200
2007-08-03,19.322857,19.421429,18.785715,18.835714,16.306028,169796900
2007-08-06,18.985714,19.324286,18.328571,19.321428,16.726513,231292600
2007-08-07,19.277143,19.605715,18.947144,19.290001,16.699303,237484100
2007-08-08,19.537144,19.551428,18.857143,19.144285,16.573160,202024200
2007-08-09,18.730000,19.000000,17.870001,18.055714,15.630785,281348900
2007-08-10,17.588572,18.250000,17.185715,17.857143,15.458884,352687300
2007-08-13,18.331429,18.478571,18.071428,18.255714,15.803925,188227900
2007-08-14,18.327143,18.328571,17.672857,17.718571,15.338919,184751700
2007-08-15,17.534286,17.837143,17.092857,17.128571,14.828159,248213000
2007-08-16,16.715714,16.928572,15.945714,16.721428,14.475695,466672500
2007-08-17,17.430000,17.642857,17.117144,17.437143,15.095286,298765600
2007-08-20,17.708570,17.785715,17.214285,17.459999,15.115072,200829300
2007-08-21,17.458570,18.422857,17.285715,18.224285,15.776716,325761800
2007-08-22,18.745714,18.964285,18.618572,18.930000,16.387651,265441400
2007-08-23,19.012857,19.048571,18.537144,18.724285,16.209562,216709500
2007-08-24,18.647142,19.338572,18.544285,19.328571,16.732693,227958500
2007-08-27,19.055714,19.237143,18.871429,18.892857,16.355499,176859900
2007-08-28,18.712856,18.915714,18.090000,18.117144,15.683966,294841400
2007-08-29,18.554285,19.168571,18.505714,19.154285,16.581816,291715200
2007-08-30,18.952858,19.750000,18.900000,19.464285,16.850187,358895600
2007-08-31,19.927143,19.950001,19.629999,19.782858,17.125967,219221800
2007-09-04,19.991428,20.818571,19.977142,20.594286,17.828417,329210700
2007-09-05,20.709999,20.834286,19.442858,19.537144,16.913256,582055600
2007-09-06,19.365715,19.652857,18.958570,19.287144,16.696829,475315400
2007-09-07,18.858572,18.900000,18.571428,18.824286,16.296139,357644000
2007-09-10,19.570000,19.719999,19.135714,19.530001,16.907070,371959700
2007-09-11,19.700001,19.757143,19.107143,19.355715,16.756191,242971400
2007-09-12,19.427143,19.914286,19.392857,19.549999,16.924383,255692500
2007-09-13,19.832857,19.857143,19.521429,19.600000,16.967672,164040800
2007-09-14,19.510000,19.854286,19.457144,19.830000,17.166782,151830000
2007-09-17,19.855715,20.084286,19.657143,19.772858,17.117311,198342900
2007-09-18,19.865715,20.407143,19.690001,20.131428,17.427729,266022400
2007-09-19,20.431429,20.451429,19.914286,20.110001,17.409178,256720100
2007-09-20,20.021429,20.255714,19.902857,20.044285,17.352289,172960200
2007-09-21,20.162857,20.664286,20.044285,20.592857,17.827177,284720100
2007-09-24,20.961428,21.407143,20.950001,21.182858,18.337940,263040400
2007-09-25,20.977142,21.888571,20.974285,21.882856,18.943932,298137700
2007-09-26,22.067142,22.142857,21.607143,21.824286,18.893229,243817000
2007-09-27,21.967142,22.074286,21.760000,22.071428,19.107178,164549700
2007-09-28,21.920000,22.085714,21.821428,21.924286,18.979799,153775300
2007-10-01,22.090000,22.487143,21.847143,22.334286,19.334732,209267100
2007-10-02,22.364286,22.655714,22.270000,22.635714,19.595680,198017400
2007-10-03,22.540001,22.740000,22.430000,22.559999,19.530134,173129600
2007-10-04,22.571428,22.582857,21.928572,22.320000,19.322367,164239600
2007-10-05,22.624287,23.082857,22.528572,23.064285,19.966690,235867800
2007-10-08,23.355715,23.987143,23.281429,23.987143,20.765610,208982200
2007-10-09,24.314285,24.444286,23.811428,23.980000,20.759422,276071600
2007-10-10,23.935715,23.982857,23.657143,23.827143,20.627096,166897500
2007-10-11,24.212856,24.554285,21.887142,23.175714,20.063156,410998000
2007-10-12,23.287144,23.897142,23.114286,23.892857,20.683983,247044000
2007-10-15,23.997143,24.224285,23.357143,23.854286,20.650597,269482500
2007-10-16,23.648571,24.311428,23.592857,24.225714,20.972137,266957600
2007-10-17,24.670000,24.719999,24.168571,24.678572,21.364176,281903300
2007-10-18,24.500000,24.884285,24.435715,24.785715,21.456932,205919000
2007-10-19,24.891428,24.947144,24.285715,24.345715,21.076019,322945000
2007-10-22,24.335714,24.985714,24.280001,24.908571,21.563292,412374900
2007-10-23,26.937143,26.942858,26.108572,26.594286,23.022606,448791000
2007-10-24,26.544285,26.744286,25.605715,26.561428,22.994158,322120400
2007-10-25,26.410000,26.557142,25.951429,26.111429,22.604597,243400500
2007-10-26,26.469999,26.481428,26.125713,26.385714,22.842047,176719200
2007-10-29,26.492857,26.655714,26.385714,26.441429,22.890278,135138500
2007-10-30,26.597143,27.052856,26.389999,26.714285,23.126490,234853500
2007-10-31,26.804285,27.160000,26.421429,27.135714,23.491320,208327700
2007-11-01,26.942858,27.157143,25.714285,26.777143,23.180906,201259100
2007-11-02,27.030001,27.062857,26.212856,26.838572,23.234079,250528600
2007-11-05,26.469999,26.994286,26.320000,26.597143,23.025074,201044200
2007-11-06,26.721428,27.428572,26.467142,27.398571,23.718870,238681800
2007-11-07,27.230000,27.525715,26.590000,26.614286,23.039913,248581900
2007-11-08,26.667143,26.700001,23.967142,25.067142,21.700562,472594500
2007-11-09,24.450001,25.017143,23.601429,23.624287,20.451479,381595200
2007-11-12,23.611429,23.957144,21.518572,21.965714,19.015661,442266300
2007-11-13,22.978571,24.425714,21.965714,24.280001,21.019136,434861700
2007-11-14,25.308571,25.367144,23.391428,23.730000,20.542997,362292000
2007-11-15,23.770000,24.227142,22.900000,23.471428,20.319155,371852600
2007-11-16,23.614286,23.860001,22.761429,23.770000,20.577629,345873500
2007-11-19,23.728571,24.028572,23.157143,23.421429,20.275867,288607200
2007-11-20,23.667143,24.541430,23.361429,24.121429,20.881855,385910700
2007-11-21,23.691429,24.621429,23.524286,24.065714,20.833626,304452400
2007-11-23,24.571428,24.578571,24.250000,24.505714,21.214533,116439400
2007-11-26,24.798571,25.324286,24.621429,24.648571,21.338203,326438700
2007-11-27,25.031429,25.112858,24.287144,24.972857,21.618935,329257600
2007-11-28,25.260000,25.799999,25.049999,25.745714,22.288002,287728000
2007-11-29,25.632856,26.452858,25.592857,26.327143,22.791342,262731700
2007-11-30,26.762857,26.814285,25.671429,26.031429,22.535343,296950500
2007-12-03,25.980000,26.305714,25.385714,25.551428,22.119802,240367400
2007-12-04,25.307142,25.842857,25.284286,25.687143,22.237297,193449900
2007-12-05,26.127142,26.571428,26.058571,26.500000,22.940983,223100500
2007-12-06,26.598572,27.157143,26.588572,27.135714,23.491320,224952700
2007-12-07,27.219999,27.855715,26.862858,27.757143,24.029287,266516600
2007-12-10,27.655714,27.951429,27.527143,27.744286,24.018152,180594400
2007-12-11,27.821428,28.118572,26.770000,26.934286,23.316942,277731300
2007-12-12,27.634285,27.782858,26.537144,27.265715,23.603859,306415200
2007-12-13,27.170000,27.445715,26.831429,27.404285,23.723820,216154400
2007-12-14,27.195715,27.600000,27.077143,27.198572,23.545734,168578200
2007-12-17,27.245714,27.521429,26.139999,26.342857,22.804941,256173400
2007-12-18,26.645714,26.761429,25.514286,26.139999,22.629332,305650800
2007-12-19,26.139999,26.377142,25.842857,26.160000,22.646641,206869600
2007-12-20,26.490000,26.832857,26.190001,26.744286,23.152458,193514300
2007-12-21,27.160000,27.701429,27.127142,27.701429,23.981054,248490200
2007-12-24,27.861429,28.475714,27.827143,28.400000,24.585808,120050700
2007-12-26,28.430000,28.708570,28.117144,28.421429,24.604359,175933100
2007-12-27,28.421429,28.994286,28.257143,28.367144,24.557364,198881900
2007-12-28,28.655714,28.794285,28.125713,28.547142,24.713190,174911800
2007-12-31,28.500000,28.642857,28.250000,28.297142,24.496765,134833300
2008-01-02,28.467142,28.608572,27.507143,27.834286,24.096073,269794700
2008-01-03,27.915714,28.198572,27.527143,27.847143,24.107191,210516600
2008-01-04,27.350000,27.571428,25.555714,25.721428,22.266973,363958000
2008-01-07,25.892857,26.228571,24.318571,25.377142,21.968927,518048300
2008-01-08,25.734285,26.065714,24.400000,24.464285,21.178667,380954000
2008-01-09,24.471428,25.642857,24.042856,25.628571,22.186584,453470500
2008-01-10,25.368572,25.857143,25.058571,25.431429,22.015921,370743800
2008-01-11,25.142857,25.407143,24.285715,24.670000,21.356754,308071400
2008-01-14,25.360001,25.631428,25.024286,25.540001,22.109911,275112600
2008-01-15,25.388571,25.602858,23.522858,24.148571,20.905354,585819500
2008-01-16,23.604286,24.144285,22.385714,22.805714,19.742846,553461300
2008-01-17,23.072857,23.622858,22.631428,22.984285,19.897436,439464900
2008-01-18,23.101429,23.678572,22.801428,23.051428,19.955557,431085900
2008-01-22,21.151428,22.854286,20.857143,22.234285,19.248163,608688500
2008-01-23,19.455715,20.000000,18.020000,19.867144,17.198933,843242400
2008-01-24,19.998571,20.100000,18.858572,19.371429,16.769798,501466700
2008-01-25,19.855715,19.870001,18.515715,18.572857,16.078474,388684800
2008-01-28,18.308571,19.028572,18.064285,18.572857,16.078474,368711000
2008-01-29,18.735714,18.969999,18.435715,18.791430,16.267689,274995700
2008-01-30,18.767143,19.350000,18.571428,18.882856,16.346848,310762900
2008-01-31,18.492857,19.521429,18.485714,19.337143,16.740110,336418600
2008-02-01,19.462856,19.512857,18.882856,19.107143,16.541006,252686000
2008-02-04,19.172857,19.414286,18.774286,18.807142,16.281294,224808500
2008-02-05,18.632856,19.142857,18.414286,18.480000,15.998084,285260500
2008-02-06,18.690001,18.845715,17.395714,17.428572,15.087870,393318100
2008-02-07,17.138571,17.825714,16.752857,17.320000,14.993879,520832900
2008-02-08,17.440001,17.957144,17.371429,17.925714,15.518245,338993200
2008-02-11,18.287144,18.568571,18.171429,18.492857,16.009224,300358100
2008-02-12,18.671429,18.714285,17.660000,17.837143,15.441566,306495000
2008-02-13,18.097143,18.540001,17.947144,18.485714,16.003035,242133500
2008-02-14,18.485714,18.685715,18.144285,18.208570,15.763113,238524300
2008-02-15,18.038572,18.154285,17.722857,17.804285,15.413123,225325100
2008-02-19,17.998571,18.107143,17.348572,17.454287,15.110127,251261500
2008-02-20,17.457144,17.799999,17.382856,17.688572,15.312953,241859800
2008-02-21,18.007143,18.067142,17.265715,17.362858,15.030981,234528700
2008-02-22,17.497143,17.501429,16.552856,17.065714,14.773746,382469500
2008-02-25,16.941429,17.167143,16.665714,17.105715,14.808373,314193600
2008-02-26,16.805714,17.298571,16.491428,17.021429,14.735406,376222000
2008-02-27,16.889999,17.578571,16.870001,17.565714,15.206594,368784500
2008-02-28,18.171429,18.885714,17.967142,18.558571,16.066101,404563600
2008-02-29,18.469999,18.601429,17.828571,17.860001,15.461356,313870200
2008-03-03,17.777143,17.997143,16.857143,17.389999,15.054481,398260800
2008-03-04,17.427143,17.840000,17.200001,17.802856,15.411883,446345900
2008-03-05,17.654285,17.877142,17.464285,17.784286,15.395814,305459000
2008-03-06,17.801428,18.214285,17.258572,17.275715,14.955544,368424700
2008-03-07,17.201429,17.568571,17.007143,17.464285,15.118788,307615700
2008-03-10,17.425714,17.637142,17.052856,17.098572,14.802184,249897200
2008-03-11,17.728571,18.211428,17.428572,18.192858,15.749511,290985800
2008-03-12,18.148571,18.382856,17.881428,18.004286,15.586265,264907300
2008-03-13,17.728571,18.500000,17.571428,18.277143,15.822478,315525700
2008-03-14,18.554285,18.614286,17.742857,18.087143,15.657992,289160200
2008-03-17,17.507143,18.370001,17.507143,18.104286,15.672834,268149700
2008-03-18,18.454287,19.000000,18.381428,18.974285,16.425983,301280000
2008-03-19,19.017143,19.184286,18.524286,18.524286,16.036427,252634200
2008-03-20,18.731428,19.041430,18.454287,19.038572,16.481640,227196900
2008-03-24,19.144285,20.121429,19.091429,19.932858,17.255827,266730100
2008-03-25,19.994286,20.442858,19.618572,20.139999,17.435146,263097800
2008-03-26,20.124287,20.820000,20.091429,20.722857,17.939724,295521100
2008-03-27,20.707144,20.758572,19.998571,20.035715,17.344868,249957400
2008-03-28,20.257143,20.664286,20.228571,20.430000,17.686199,178652600
2008-03-31,20.467142,20.815714,20.360001,20.500000,17.746798,192016300
2008-04-01,20.900000,21.379999,20.515715,21.361429,18.492531,258141800
2008-04-02,21.254286,21.600000,20.835714,21.070000,18.240250,261242100
2008-04-03,21.008572,21.947144,21.000000,21.658571,18.749775,262892000
2008-04-04,21.741428,22.101429,21.535715,21.868572,18.931566,213604300
2008-04-07,22.304285,22.812857,22.158571,22.270000,19.279078,289581600
2008-04-08,21.935715,22.350000,21.760000,21.834286,18.901884,253573600
2008-04-09,21.901428,21.984285,21.494286,21.634285,18.728745,218349600
2008-04-10,21.590000,22.202858,21.514286,22.078571,19.113354,238940800
2008-04-11,21.817142,21.900000,20.914286,21.020000,18.196959,302519000
2008-04-14,20.967142,21.321428,20.648571,21.111429,18.276108,211271900
2008-04-15,21.342857,21.388571,20.817142,21.197144,18.350309,174509300
2008-04-16,21.674286,22.014286,21.517143,21.957144,19.008244,198943500
2008-04-17,22.024286,22.285715,21.907143,22.070000,19.105936,176066800
2008-04-18,22.731428,23.180000,22.625713,23.005714,19.915983,256691400
2008-04-21,23.172857,24.071428,23.108572,24.022858,20.796524,259788200
2008-04-22,23.914286,24.000000,22.584286,22.885714,19.812107,359893100
2008-04-23,23.435715,23.548571,23.011429,23.270000,20.144779,376047700
2008-04-24,23.620001,24.282858,22.741428,24.134285,20.892986,424016600
2008-04-25,24.385714,24.442858,23.774286,24.247143,20.990690,248118500
2008-04-28,24.250000,24.821428,24.161428,24.605715,21.301104,196803600
2008-04-29,24.444286,25.094286,24.321428,25.007143,21.648617,230869100
2008-04-30,25.170000,25.714285,24.702858,24.850000,21.512579,284881100
2008-05-01,24.994286,25.714285,24.980000,25.714285,22.260792,225894200
2008-05-02,25.741428,25.988571,25.507143,25.848572,22.377045,251520500
2008-05-05,25.988571,26.472857,25.864286,26.389999,22.845753,213639300
2008-05-06,26.379999,26.731428,26.025715,26.665714,23.084436,229717600
2008-05-07,26.578571,26.885714,25.791430,26.084286,22.581099,289283400
2008-05-08,26.252857,26.642857,26.152857,26.437143,22.886564,224771400
2008-05-09,26.165714,26.321428,25.910000,26.207144,22.687452,168268100
2008-05-12,26.458570,26.981428,26.121429,26.879999,23.269943,204640800
2008-05-13,26.944286,27.350000,26.837143,27.137142,23.492554,205809100
2008-05-14,27.318571,27.462856,26.510000,26.608572,23.034977,229205900
2008-05-15,26.687143,27.128571,26.314285,27.104286,23.464109,218302000
2008-05-16,27.158571,27.185715,26.714285,26.802856,23.203161,191442300
2008-05-19,26.837143,26.955715,25.900000,26.228571,22.706005,236455100
2008-05-20,25.974285,26.594286,25.731428,26.557142,22.990450,242462500
2008-05-21,26.524286,26.850000,25.178572,25.455715,22.036943,289414300
2008-05-22,25.608572,25.904285,24.571428,25.292856,21.895960,301683900
2008-05-23,25.824286,25.998571,25.400000,25.881428,22.405485,226729300
2008-05-27,26.107143,26.632856,25.977142,26.632856,23.055990,197476300
2008-05-28,26.772858,26.850000,26.245714,26.715714,23.127718,185994900
2008-05-29,26.680000,26.885714,26.500000,26.670000,23.088144,161796600
2008-05-30,26.778572,27.077143,26.768572,26.964285,23.342916,152546100
2008-06-02,26.942858,27.092857,26.361429,26.585714,23.015188,169960000
2008-06-03,26.694286,26.885714,26.048571,26.481428,22.924902,187630100
2008-06-04,26.288572,26.727142,26.175714,26.455715,22.902647,181745900
2008-06-05,26.620001,27.120001,26.528572,27.061428,23.427008,188861400
2008-06-06,26.857143,27.135714,26.507143,26.520000,22.958296,241605700
2008-06-09,26.398571,26.420000,25.107143,25.944286,22.459904,472098200
2008-06-10,25.787144,26.682858,25.574286,26.520000,22.958296,285235300
2008-06-11,26.334286,26.571428,25.655714,25.830000,22.360960,240387700
2008-06-12,25.927143,26.085714,24.457144,24.751429,21.427246,327083400
2008-06-13,24.520000,24.879999,23.615715,24.624287,21.317177,336489300
2008-06-16,24.471428,25.414286,24.152857,25.262857,21.869989,262932600
2008-06-17,25.442858,25.998571,25.344286,25.918571,22.437641,224914200
2008-06-18,25.874287,26.028572,25.335714,25.535715,22.106197,202867000
2008-06-19,25.507143,26.048571,25.257143,25.842857,22.372097,197987300
2008-06-20,25.621429,25.857143,25.000000,25.038572,21.675827,222091800
2008-06-23,24.962856,25.125713,24.508572,24.737143,21.414881,161445200
2008-06-24,24.624287,25.111429,24.518572,24.750000,21.426006,155486800
2008-06-25,24.944286,25.547142,24.840000,25.341429,21.938009,161112700
2008-06-26,24.867144,24.977142,24.001429,24.037144,20.808895,217402500
2008-06-27,23.787144,24.367144,23.450001,24.298571,21.035213,260562400
2008-06-30,24.312857,24.571428,23.802856,23.920000,20.707483,171049200
2008-07-01,23.461428,24.959999,23.428572,24.954287,21.602856,277820200
2008-07-02,25.028572,25.350000,24.025715,24.025715,20.798998,209379800
2008-07-03,24.227142,24.595715,23.678572,24.302856,21.038919,130840500
2008-07-07,24.737143,25.304285,24.557142,25.022858,21.662218,205097900
2008-07-08,25.057142,25.671429,24.677143,25.650000,22.205139,222087600
2008-07-09,25.742857,25.844286,24.877142,24.892857,21.549679,223944000
2008-07-10,24.988571,25.334286,24.481428,25.232857,21.844019,210172200
2008-07-11,25.067142,25.301428,24.428572,24.654285,21.343151,232502900
2008-07-14,25.605715,25.614286,24.725714,24.840000,21.503923,221513600
2008-07-15,24.639999,24.820000,23.770000,24.234285,20.979557,260010800
2008-07-16,24.314285,24.704287,24.085714,24.687143,21.371595,186947600
2008-07-17,24.871429,24.997143,24.484285,24.544285,21.247923,189381500
2008-07-18,24.074286,24.235714,23.571428,23.592857,20.424269,217103600
2008-07-21,23.842857,23.928572,23.017143,23.755714,20.565264,340117400
2008-07-22,21.285715,23.251429,20.932858,23.145714,20.037188,469898100
2008-07-23,23.570000,24.052856,23.080000,23.751429,20.561554,265442100
2008-07-24,23.474285,23.608572,22.635714,22.718571,19.667406,209904800
2008-07-25,22.914286,23.285715,22.664286,23.160000,20.049549,158409300
2008-07-28,23.191429,23.209999,22.002857,22.057142,19.094814,195178200
2008-07-29,22.201429,22.778572,21.950001,22.440001,19.426250,171017700
2008-07-30,22.540001,22.927143,22.297142,22.840000,19.772530,181295800
2008-07-31,22.505714,23.171429,22.425714,22.707144,19.657515,159374600
2008-08-01,22.842857,22.855715,22.250000,22.379999,19.374306,136159800
2008-08-04,22.371429,22.557142,21.844286,21.889999,18.950113,148131900
2008-08-05,22.202858,22.971428,22.117144,22.948572,19.866512,172092900
2008-08-06,22.852858,23.914286,22.571428,23.455715,20.305553,197852200
2008-08-07,23.244286,23.735714,23.071428,23.367144,20.228878,168093100
2008-08-08,23.408571,24.235714,23.392857,24.221428,20.968426,178499300
2008-08-11,24.295713,25.214285,24.238571,24.794285,21.464348,222826100
2008-08-12,24.788572,25.612858,24.787144,25.247143,21.856388,209069700
2008-08-13,25.425714,25.714285,25.128571,25.614286,22.174221,210586600
2008-08-14,25.475714,25.778572,25.405714,25.617144,22.176693,177825200
2008-08-15,25.577143,25.678572,25.007143,25.105715,21.733953,177062900
2008-08-18,25.081429,25.401428,24.831429,25.055714,21.690670,138003600
2008-08-19,24.934286,25.295713,24.544285,24.790001,21.460636,154051100
2008-08-20,24.967142,25.277143,24.801428,25.120001,21.746317,126737800
2008-08-21,24.924286,25.064285,24.555714,24.898571,21.554625,134936200
2008-08-22,25.117144,25.357143,25.081429,25.255714,21.863808,109902800
2008-08-25,25.164286,25.175714,24.522858,24.650000,21.339443,121106300
2008-08-26,24.680000,24.982857,24.658571,24.805714,21.474251,111387500
2008-08-27,24.758572,25.108572,24.598572,24.952858,21.601627,119445200
2008-08-28,25.040001,25.178572,24.678572,24.820000,21.486607,107846200
2008-08-29,24.708570,24.785715,24.148571,24.218571,20.965956,149822400
2008-09-02,24.628571,24.785715,23.571428,23.741428,20.552891,195190800
2008-09-03,23.834286,24.097143,23.428572,23.851429,20.648119,183708700
2008-09-04,23.694286,23.987143,22.972857,23.031429,19.938246,185846500
2008-09-05,22.655714,23.200001,22.521429,22.882856,19.809626,196721000
2008-09-08,23.510000,23.555714,21.637142,22.559999,19.530134,261494800
2008-09-09,22.408571,22.851429,21.398571,21.668571,18.758421,311256400
2008-09-10,21.760000,22.141428,21.257143,21.658571,18.749775,243285700
2008-09-11,21.168571,21.855715,20.857143,21.807142,18.878386,242783800
2008-09-12,21.558571,21.558571,20.928572,21.277143,18.419565,198256800
2008-09-15,20.290001,21.098572,20.051428,20.051428,17.358465,230158600
2008-09-16,19.122858,20.357143,18.878571,19.982857,17.299109,299959100
2008-09-17,19.784286,19.787144,18.261429,18.261429,15.808873,300113800
2008-09-18,18.652857,19.347143,17.240000,19.155714,16.583046,419063400
2008-09-19,20.371429,20.600000,19.472857,20.129999,17.426487,357718900
2008-09-22,19.991428,20.035715,18.665714,18.721428,16.207098,214178300
2008-09-23,18.835714,19.400000,18.094286,18.120001,15.686438,320091100
2008-09-24,18.181429,18.707144,17.878571,18.387142,15.917701,261753800
2008-09-25,18.542856,19.255714,18.360001,18.847143,16.315922,251511400
2008-09-26,17.844286,18.542856,17.571428,18.320000,15.859579,281612800
2008-09-29,17.088572,17.097143,14.370000,15.037143,13.017612,655514300
2008-09-30,15.464286,16.428572,15.185715,16.237143,14.056450,406670600
2008-10-01,15.988571,16.051428,15.341429,15.588572,13.494987,324121000
2008-10-02,15.430000,15.541429,14.285714,14.300000,12.379473,402341100
2008-10-03,14.857142,15.214286,13.521428,13.867143,12.004747,573599600
2008-10-06,13.137143,14.111428,12.505714,14.020000,12.137077,526854300
2008-10-07,14.354285,14.500000,12.707143,12.737143,11.026513,469693000
2008-10-08,12.272857,13.761429,12.240000,12.827143,11.104424,551935300
2008-10-09,13.335714,13.685715,12.371428,12.677143,10.974570,404345900
2008-10-10,12.242857,14.285714,12.142858,13.828571,11.971361,554824900
2008-10-13,14.935715,15.790000,14.431429,15.751429,13.635969,384769000
2008-10-14,16.608572,16.628571,14.734285,14.868571,12.871682,495248600
2008-10-15,14.834286,15.285714,13.984285,13.992857,12.113578,396043900
2008-10-16,14.252857,14.775714,13.105714,14.555715,12.600843,495130300
2008-10-17,14.228572,14.577143,12.270000,13.914286,12.045562,440556900
2008-10-20,14.254286,14.290000,13.377143,14.062857,12.174176,387292500
2008-10-21,13.850000,13.985714,13.022857,13.070000,11.314666,548415000
2008-10-22,13.910000,14.464286,13.275714,13.838572,11.980017,562202200
2008-10-23,13.787143,14.178572,13.128572,14.032857,12.148210,418857600
2008-10-24,12.904285,13.985714,12.872857,13.768572,11.919416,397514600
2008-10-27,13.581429,13.947143,13.122857,13.155714,11.388865,302192800
2008-10-28,13.632857,14.357142,13.195714,14.272857,12.355974,408533300
2008-10-29,14.408571,15.648571,14.277143,14.935715,12.929809,487744600
2008-10-30,15.461429,16.027143,15.372857,15.862857,13.732431,409522400
2008-10-31,15.342857,15.825714,15.020000,15.370000,13.305768,414939000
2008-11-03,15.132857,15.585714,14.980000,15.280000,13.227857,264484500
2008-11-04,15.712857,15.970000,15.238571,15.855714,13.726250,349670300
2008-11-05,15.558572,15.674286,14.712857,14.757143,12.775220,314113800
2008-11-06,14.435715,14.682858,14.000000,14.157143,12.255801,329768600
2008-11-07,14.177143,14.264286,13.674286,14.034286,12.149447,273813400
2008-11-10,14.310000,14.342857,13.500000,13.697143,11.857582,280955500
2008-11-11,13.544286,13.881429,13.180000,13.538571,11.720304,306134500
2008-11-12,13.204286,13.320000,12.858571,12.874286,11.145237,294744100
2008-11-13,12.838572,13.777143,12.288571,13.777143,11.926837,463521800
2008-11-14,13.394286,13.427143,12.857142,12.891429,11.160077,351316700
2008-11-17,12.640000,12.935715,12.465714,12.591429,10.900368,290631600
2008-11-18,12.805715,12.998571,12.408571,12.844286,11.119262,302423800
2008-11-19,12.777143,13.082857,12.315714,12.327143,10.671576,292975200
2008-11-20,12.177143,12.350000,11.428572,11.498571,9.954283,429203600
2008-11-21,11.704286,12.017143,11.305715,11.797143,10.212755,392317800
2008-11-24,12.172857,13.541429,12.120000,13.278571,11.495225,360564400
2008-11-25,13.518572,13.530000,12.594286,12.971429,11.229332,308823200
2008-11-26,12.845715,13.607142,12.835714,13.571428,11.748752,224959000
2008-11-28,13.528571,13.537143,13.122857,13.238571,11.460600,74443600
2008-12-01,13.042857,13.181429,12.702857,12.704286,10.998066,230941900
2008-12-02,12.861428,13.235714,12.357142,13.210000,11.435863,287180600
2008-12-03,12.771428,13.747143,12.685715,13.700000,11.860058,334670000
2008-12-04,13.490000,13.601429,12.722857,13.058572,11.304772,272842500
2008-12-05,12.907143,13.498571,12.694285,13.428572,11.625082,260948800
2008-12-08,13.897142,14.400000,13.685715,14.245714,12.332478,296285500
2008-12-09,14.005714,14.800000,13.887143,14.294286,12.374527,300874000
2008-12-10,13.981428,14.212857,13.785714,14.030000,12.145735,234511900
2008-12-11,13.907143,14.462857,13.547143,13.571428,11.748752,260154300
2008-12-12,13.257143,14.142858,13.218572,14.038571,12.153152,260293600
2008-12-15,13.712857,13.744286,13.285714,13.535714,11.717833,222939500
2008-12-16,13.425714,13.782857,13.250000,13.632857,11.801929,273376600
2008-12-17,13.004286,13.014286,12.574286,12.737143,11.026513,323465100
2008-12-18,12.758572,12.975715,12.634286,12.775714,11.059901,214354000
2008-12-19,12.848572,12.991428,12.685715,12.857142,11.130396,200480000
2008-12-22,12.860000,12.861428,12.098572,12.248571,10.603558,211185100
2008-12-23,12.410000,12.552857,12.271428,12.340000,10.682709,158757900
2008-12-24,12.305715,12.321428,12.078571,12.148571,10.516987,67833500
2008-12-26,12.377143,12.488571,12.177143,12.258572,10.612212,77081200
2008-12-29,12.360000,12.517143,12.152857,12.372857,10.711150,171500000
2008-12-30,12.488571,12.578571,12.102858,12.327143,10.671576,241900400
2008-12-31,12.281428,12.534286,12.191428,12.192857,10.555326,151885300
2009-01-02,12.268572,13.005714,12.165714,12.964286,11.223147,186503800
2009-01-05,13.310000,13.740000,13.244286,13.511429,11.696809,295402100
2009-01-06,13.707143,13.881429,13.198571,13.288571,11.503882,322327600
2009-01-07,13.115714,13.214286,12.894286,13.001429,11.255305,188262200
2009-01-08,12.918571,13.307143,12.862857,13.242857,11.464305,168375200
2009-01-09,13.315714,13.340000,12.877143,12.940000,11.202125,136711400
2009-01-12,12.922857,12.998571,12.507143,12.665714,10.964678,154429100
2009-01-13,12.605714,12.820000,12.335714,12.530000,10.847189,199599400
2009-01-14,12.320000,12.464286,12.102858,12.190000,10.552851,255416000
2009-01-15,11.510000,12.017143,11.435715,11.911428,10.311691,457908500
2009-01-16,12.042857,12.054286,11.485714,11.761429,10.181838,261906400
2009-01-20,11.704286,11.714286,11.171429,11.171429,9.671075,229978700
2009-01-21,11.341429,11.840000,11.330000,11.832857,10.243671,272317500
2009-01-22,12.577143,12.857142,12.260000,12.622857,10.927574,352382100
2009-01-23,12.402857,12.838572,12.357142,12.622857,10.927574,190942500
2009-01-26,12.694285,12.995714,12.614285,12.805715,11.085875,173059600
2009-01-27,12.884286,13.078571,12.820000,12.961429,11.220674,154509600
2009-01-28,13.160000,13.571428,13.071428,13.457143,11.649816,215351500
2009-01-29,13.298572,13.477143,13.228572,13.285714,11.501410,148182300
2009-01-30,13.228572,13.374286,12.858571,12.875714,11.146472,162869700
2009-02-02,12.728572,13.142858,12.700000,13.072857,11.317137,139561800
2009-02-03,13.131429,13.340000,12.897142,13.282857,11.498934,149827300
2009-02-04,13.317142,13.750000,13.300000,13.364285,11.569427,202105400
2009-02-05,13.252857,13.892858,13.231428,13.780000,11.929309,187311600
2009-02-06,13.860000,14.285714,13.857142,14.245714,12.332478,171802400
2009-02-09,14.285714,14.714286,14.214286,14.644286,12.677522,178752700
2009-02-10,14.475715,14.644286,13.865714,13.975715,12.098739,212265200
2009-02-11,13.767143,14.044286,13.681429,13.831429,11.973831,168743400
2009-02-12,13.690000,14.250000,13.690000,14.181429,12.276825,204297100
2009-02-13,14.141429,14.277143,14.017143,14.165714,12.263221,152244400
2009-02-17,13.838572,13.862857,13.468572,13.504286,11.690626,169559600
2009-02-18,13.578571,13.692857,13.245714,13.481428,11.670837,171194800
2009-02-19,13.338572,13.464286,12.872857,12.948571,11.209543,230701100
2009-02-20,12.771428,13.200000,12.714286,13.028571,11.278802,187579000
2009-02-23,13.092857,13.142858,12.358571,12.421429,10.753200,196745500
2009-02-24,12.492857,12.984285,12.428572,12.892858,11.161312,201776400
2009-02-25,12.837143,13.274285,12.750000,13.022857,11.273849,208263300
2009-02-26,13.142858,13.274285,12.708571,12.741428,11.030221,157467100
2009-02-27,12.561429,13.042857,12.524285,12.758572,11.045059,176664600
2009-03-02,12.588572,13.028571,12.524285,12.562857,10.875631,192732400
2009-03-03,12.704286,12.962857,12.554286,12.624286,10.928811,181085100
2009-03-04,12.882857,13.252857,12.778571,13.024285,11.275091,185350900
2009-03-05,12.922857,13.124286,12.635715,12.691428,10.986937,176724800
2009-03-06,12.620000,12.628572,11.761429,12.185715,10.549142,252786800
2009-03-09,12.025714,12.514286,11.795714,11.872857,10.278301,174574400
2009-03-10,12.124286,12.738571,12.051429,12.661428,10.960966,211064700
2009-03-11,12.830000,13.438571,12.797143,13.240000,11.461835,211593200
2009-03-12,13.271428,13.797143,13.142858,13.764286,11.915707,192114300
2009-03-13,13.757143,13.885715,13.572857,13.704286,11.863766,150292100
2009-03-16,13.790000,13.912857,13.454286,13.631429,11.800693,199311000
2009-03-17,13.605714,14.241428,13.581429,14.237143,12.325058,196661500
2009-03-18,14.272857,14.782857,14.245714,14.502857,12.555087,199009300
2009-03-19,14.550000,14.742857,14.321428,14.517143,12.567451,125045200
2009-03-20,14.584286,14.730000,14.367143,14.512857,12.563742,173896800
2009-03-23,14.672857,15.451428,14.535714,15.380000,13.314426,166599300
2009-03-24,15.194285,15.634286,15.055715,15.214286,13.170968,160153000
2009-03-25,15.368571,15.480000,14.837143,15.212857,13.169731,161654500
2009-03-26,15.404285,15.711429,15.368571,15.695714,13.587737,154063000
2009-03-27,15.461429,15.504286,15.200000,15.264286,13.214252,123218200
2009-03-30,14.930000,15.001429,14.658571,14.927143,12.922390,125699000
2009-03-31,15.064285,15.350000,15.000000,15.017143,13.000303,142520000
2009-04-01,14.870000,15.571428,14.841429,15.527143,13.441809,147343000
2009-04-02,15.734285,16.392857,15.682858,16.101429,13.938966,203091700
2009-04-03,16.312857,16.590000,16.217142,16.570000,14.344605,159060300
2009-04-06,16.420000,16.964285,16.182858,16.921429,14.648834,164516100
2009-04-07,16.647142,16.667143,16.312857,16.428572,14.222171,134145200
2009-04-08,16.490000,16.684286,16.368572,16.617144,14.385418,113907500
2009-04-09,16.917143,17.142857,16.851429,17.081429,14.787349,132689200
2009-04-13,17.144285,17.282858,17.000000,17.174286,14.867738,97309100
2009-04-14,17.081429,17.167143,16.750000,16.901428,14.631524,113655500
2009-04-15,16.742857,16.892857,16.537144,16.805714,14.548663,103220600
2009-04-16,17.027143,17.592857,16.969999,17.350000,15.019844,148361500
2009-04-17,17.311428,17.750000,17.178572,17.631428,15.263478,124373900
2009-04-20,17.389999,17.570000,17.022858,17.214285,14.902363,116616500
2009-04-21,16.984285,17.448572,16.942858,17.394285,15.058187,117671400
2009-04-22,17.518572,17.907143,17.314285,17.358572,15.027266,234691800
2009-04-23,18.088572,18.171429,17.644285,17.914286,15.508345,236289200
2009-04-24,17.805714,17.877142,17.567142,17.700001,15.322845,135191000
2009-04-27,17.557142,17.857143,17.522858,17.818571,15.425488,120172500
2009-04-28,17.621429,18.030001,17.608572,17.700001,15.322845,113964200
2009-04-29,17.835714,18.121429,17.690001,17.877142,15.476197,114527700
2009-04-30,18.031429,18.142857,17.845715,17.975714,15.561527,124622400
2009-05-01,17.971428,18.278572,17.971428,18.177143,15.735903,99379000
2009-05-04,18.320000,18.892857,18.240000,18.867144,16.333237,152339600
2009-05-05,18.821428,18.980000,18.731428,18.958570,16.412386,99563800
2009-05-06,19.047142,19.071428,18.602858,18.928572,16.386417,118384700
2009-05-07,18.904285,18.912857,18.271429,18.437143,15.960989,132944000
2009-05-08,18.434286,18.747143,18.037144,18.455715,15.977063,116991000
2009-05-11,18.195715,18.708570,18.160000,18.510000,16.024052,101164700
2009-05-12,18.508572,18.530001,17.607143,17.774286,15.387154,152370400
2009-05-13,17.601429,17.717142,17.054285,17.070000,14.777458,148992900
2009-05-14,17.111429,17.647142,17.100000,17.564285,15.205353,111956600
2009-05-15,17.474285,17.802856,17.372858,17.488571,15.139811,91891800
2009-05-18,17.675714,18.100000,17.367144,18.092857,15.662940,114710400
2009-05-19,18.117144,18.472857,17.962856,18.207144,15.761878,93105600
2009-05-20,18.232857,18.458570,17.900000,17.981428,15.566477,97146000
2009-05-21,17.878571,18.111429,17.555714,17.740000,15.357468,101986500
2009-05-22,17.721428,17.740000,17.392857,17.500000,15.149704,74499600
2009-05-26,17.822857,18.690001,17.792856,18.682858,16.173700,159231800
2009-05-27,18.825714,19.282858,18.701429,19.007143,16.454433,161605500
2009-05-28,19.064285,19.341429,18.861429,19.295713,16.704248,121888200
2009-05-29,19.341429,19.414286,19.121429,19.401428,16.795763,114133600
2009-06-01,19.495714,19.998571,19.428572,19.907143,17.233564,113124900
2009-06-02,19.855715,20.191429,19.764286,19.927143,17.250879,114055900
2009-06-03,20.000000,20.158571,19.867144,20.135714,17.431435,141299900
2009-06-04,20.018572,20.597143,20.005714,20.534286,17.776474,137658500
2009-06-05,20.758572,20.914286,20.458570,20.667143,17.891493,158179000
2009-06-08,20.545713,20.604286,19.918571,20.549999,17.790079,232913100
2009-06-09,20.544285,20.651428,20.078571,20.388571,17.650331,169241100
2009-06-10,20.325714,20.335714,19.757143,20.035715,17.344868,172155900
2009-06-11,19.935715,20.222857,19.792856,19.992857,17.307766,131205900
2009-06-12,19.830000,19.871429,19.434286,19.567142,16.939226,140771400
2009-06-15,19.430000,19.561428,19.270000,19.441429,16.830395,134937600
2009-06-16,19.522858,19.781429,19.442858,19.478571,16.862553,128701300
2009-06-17,19.524286,19.635714,19.218571,19.368572,16.767323,142853200
2009-06-18,19.444286,19.714285,19.370001,19.411428,16.804422,106920100
2009-06-19,19.724285,19.928572,19.557142,19.925714,17.249638,180464200
2009-06-22,20.095715,20.222857,19.475714,19.624287,16.988697,158728500
2009-06-23,19.485714,19.564285,18.982857,19.144285,16.573160,176633100
2009-06-24,19.345715,19.642857,19.265715,19.459999,16.846472,121381400
2009-06-25,19.392857,20.028572,19.315714,19.980000,17.296631,147361900
2009-06-26,19.969999,20.508572,19.962856,20.348572,17.615707,109846100
2009-06-29,20.494286,20.564285,20.219999,20.281429,17.557579,141904000
2009-06-30,20.368572,20.542856,20.257143,20.347143,17.614468,108556000
2009-07-01,20.500000,20.665714,20.360001,20.404285,17.663937,103544700
2009-07-02,20.178572,20.404285,19.969999,20.002857,17.316422,92619800
2009-07-06,19.814285,19.855715,19.464285,19.801428,17.142044,124672100
2009-07-07,19.782858,19.954287,19.311428,19.342857,16.745068,115399200
2009-07-08,19.417143,19.719999,19.202858,19.602858,16.970142,143982300
2009-07-09,19.680000,19.712856,19.418571,19.480000,16.863781,85756300
2009-07-10,19.477142,19.852858,19.474285,19.788572,17.130920,111318900
2009-07-13,19.934286,20.334286,19.647142,20.334286,17.603334,120875300
2009-07-14,20.290001,20.454287,20.165714,20.324286,17.594685,86811900
2009-07-15,20.719999,21.000000,20.617144,20.982857,18.164808,121396800
2009-07-16,20.822857,21.145714,20.795713,21.074286,18.243958,98392700
2009-07-17,21.297142,21.717142,21.232857,21.678572,18.767080,150538500
2009-07-20,21.895714,22.148571,21.555714,21.844286,18.910545,183881600
2009-07-21,21.898571,21.918571,21.392857,21.644285,18.737402,218695400
2009-07-22,22.541430,22.675714,22.301428,22.391428,19.384203,218526000
2009-07-23,22.375713,22.634285,22.222857,22.545713,19.517771,131740700
2009-07-24,22.421429,22.857143,22.357143,22.855715,19.786135,109590600
2009-07-27,22.881428,22.982857,22.465714,22.871429,19.799734,108327800
2009-07-28,22.697144,22.871429,22.514286,22.857143,19.787371,90888700
2009-07-29,22.700001,22.921429,22.607143,22.861429,19.791079,95539500
2009-07-30,23.100000,23.531429,23.071428,23.255714,20.132418,117401200
2009-07-31,23.284286,23.571428,23.272858,23.341429,20.206615,105634200
2009-08-03,23.601429,23.805714,23.552856,23.775715,20.582575,98560000
2009-08-04,23.561428,23.652857,23.458570,23.650000,20.473751,98952700
2009-08-05,23.678572,23.912857,23.458570,23.587143,20.419333,105795900
2009-08-06,23.654285,23.787144,23.298571,23.415714,20.270926,85404200
2009-08-07,23.641428,23.799999,23.542856,23.644285,20.468794,96838700
2009-08-10,23.665714,23.799999,23.379999,23.531429,20.371098,75073600
2009-08-11,23.384285,23.482857,23.125713,23.261429,20.137358,88835600
2009-08-12,23.221428,23.815714,23.208570,23.615715,20.444059,111267800
2009-08-13,23.807142,24.095715,23.785715,24.059999,20.828680,109995200
2009-08-14,23.991428,24.032858,23.647142,23.825714,20.625860,76454000
2009-08-17,23.364286,23.370001,22.774286,22.798571,19.736664,131095300
2009-08-18,23.090000,23.462856,23.058571,23.428572,20.282049,107788100
2009-08-19,23.250000,23.614286,23.207144,23.514286,20.356253,103317900
2009-08-20,23.568571,23.817142,23.515715,23.761429,20.570208,85507800
2009-08-21,23.950001,24.195715,23.828571,24.174286,20.927612,104018600
2009-08-24,24.302856,24.387142,24.038572,24.151428,20.907831,101732400
2009-08-25,24.208570,24.420000,24.161428,24.200001,20.949877,81088700
2009-08-26,24.131428,24.221428,23.822857,23.915714,20.703770,75999700
2009-08-27,24.107143,24.224285,23.547142,24.207144,20.956059,112295400
2009-08-28,24.610001,24.641428,24.075714,24.292856,21.030260,113425200
2009-08-31,24.022858,24.121429,23.785715,24.030001,20.802713,77834400
2009-09-01,23.998571,24.285715,23.562857,23.614286,20.442825,117257000
2009-09-02,23.517143,23.944286,23.444286,23.597143,20.427990,91062300
2009-09-03,23.777143,23.871429,23.571428,23.792856,20.597416,73488800
2009-09-04,23.897142,24.385714,23.870001,24.330000,21.062418,93657200
2009-09-08,24.711428,24.734285,24.571428,24.704287,21.386440,78761900
2009-09-09,24.682858,24.924286,24.242857,24.448572,21.165066,202771800
2009-09-10,24.580000,24.750000,24.401428,24.651428,21.340673,122783500
2009-09-11,24.701429,24.740000,24.410000,24.594286,21.291210,87240300
2009-09-14,24.404285,24.842857,24.321428,24.817142,21.484138,80502800
2009-09-15,24.862858,25.092857,24.798571,25.022858,21.662218,106617700
2009-09-16,25.427143,26.107143,25.411428,25.981428,22.492052,188505800
2009-09-17,25.997143,26.684286,25.995714,26.364286,22.823492,202643000
2009-09-18,26.547142,26.650000,26.394285,26.431429,22.881620,150395700
2009-09-21,26.327143,26.451429,25.945715,26.288572,22.757950,109428900
2009-09-22,26.455715,26.482857,26.121429,26.354286,22.814838,89188400
2009-09-23,26.485714,26.985714,26.432858,26.500000,22.940983,148390900
2009-09-24,26.742857,26.814285,26.110001,26.260000,22.733213,137720100
2009-09-25,26.001429,26.500000,25.920000,26.052856,22.553890,111309800
2009-09-28,26.267143,26.668571,26.190001,26.592857,23.021366,84361200
2009-09-29,26.675714,26.771429,26.330000,26.482857,22.926140,86346400
2009-09-30,26.590000,26.635714,26.087143,26.478571,22.922430,134896300
2009-10-01,26.478571,26.602858,25.814285,25.837143,22.367144,131177900
2009-10-02,25.915714,26.562857,25.907143,26.414286,22.866777,138327000
2009-10-05,26.600000,26.694286,26.324286,26.574286,23.005293,105783300
2009-10-06,26.820000,27.144285,26.757143,27.144285,23.498735,151271400
2009-10-07,27.108572,27.221428,27.004286,27.178572,23.528416,116417000
2009-10-08,27.237143,27.350000,26.984285,27.038572,23.407223,109552800
2009-10-09,26.995714,27.242857,26.945715,27.209999,23.555622,73318000
2009-10-12,27.288572,27.358572,27.091429,27.258572,23.597675,72006200
2009-10-13,27.232857,27.309999,27.100000,27.145714,23.499971,87005100
2009-10-14,27.464285,27.474285,27.175714,27.327143,23.657038,93877700
2009-10-15,27.090000,27.274286,27.075714,27.222857,23.566757,93389100
2009-10-16,27.049999,27.194286,26.834286,26.864286,23.256342,107856700
2009-10-19,26.835714,27.142857,26.507143,27.122858,23.480186,235557700
2009-10-20,28.657143,28.821428,28.264286,28.394285,24.580854,285259800
2009-10-21,28.502857,29.815714,28.461428,29.274286,25.342674,298431700
2009-10-22,29.242857,29.692858,28.930000,29.314285,25.377306,197848000
2009-10-23,29.385714,29.400000,29.032858,29.134285,25.221478,105196700
2009-10-26,29.095715,29.535715,28.585714,28.925714,25.040916,121084600
2009-10-27,28.808571,28.972857,28.064285,28.195715,24.408958,189137900
2009-10-28,28.244286,28.288572,27.299999,27.485714,23.794312,204596700
2009-10-29,27.857143,28.115715,27.448572,28.049999,24.282812,142567600
2009-10-30,28.008572,28.114286,26.881428,26.928572,23.311996,179381300
2009-11-02,27.114286,27.554285,26.510000,27.044285,23.412172,169745800
2009-11-03,26.835714,27.074286,26.559999,26.964285,23.342916,130635400
2009-11-04,27.247143,27.692858,27.175714,27.258572,23.597675,121882600
2009-11-05,27.485714,27.857143,27.402857,27.718571,23.995897,96200300
2009-11-06,27.501429,27.884285,27.485714,27.762857,24.034229,73774400
2009-11-09,28.134285,28.842857,28.037144,28.780001,24.914774,132213900
2009-11-10,28.717142,29.282858,28.715714,28.997143,25.102751,100298800
2009-11-11,29.222857,29.285715,28.832857,29.035715,25.136141,110967500
2009-11-12,29.020000,29.267143,28.775715,28.855715,24.980318,90932800
2009-11-13,28.981428,29.261429,28.867144,29.207144,25.284544,85810200
2009-11-16,29.354286,29.714285,29.287144,29.518572,25.554153,121301600
2009-11-17,29.440001,29.634285,29.285715,29.571428,25.599911,99128400
2009-11-18,29.505714,29.571428,29.142857,29.422857,25.471292,93580200
2009-11-19,29.230000,29.230000,28.542856,28.644285,24.797285,135581600
2009-11-20,28.450001,28.627142,28.251429,28.559999,24.724318,101666600
2009-11-23,29.000000,29.428572,28.992857,29.411428,25.461395,118724200
2009-11-24,29.332857,29.411428,28.985714,29.205715,25.283312,79609600
2009-11-25,29.342857,29.378571,29.108572,29.170000,25.252392,71613500
2009-11-27,28.459999,28.994286,28.338572,28.655714,24.807182,73814300
2009-11-30,28.730000,28.811428,28.395714,28.558571,24.723078,106214500
2009-12-01,28.891428,28.967142,28.118572,28.138571,24.359488,116440800
2009-12-02,28.422857,28.774286,27.964285,28.032858,24.267975,178815000
2009-12-03,28.202858,28.425714,28.038572,28.068571,24.298895,112179900
2009-12-04,28.528572,28.554285,27.182858,27.617144,23.908087,206721200
2009-12-07,27.617144,27.681429,26.954287,26.992857,23.367653,178689700
2009-12-08,27.051428,27.478571,26.957144,27.124287,23.481421,172599700
2009-12-09,27.325714,28.308571,27.187143,28.257143,24.462133,171195500
2009-12-10,28.500000,28.528572,28.017143,28.061428,24.292704,122417400
2009-12-11,28.254286,28.285715,27.632856,27.809999,24.075047,107443700
2009-12-14,27.910000,28.204287,27.508572,28.139999,24.360725,123947600
2009-12-15,27.975714,28.215714,27.610001,27.738571,24.013208,104864900
2009-12-16,27.871429,28.071428,27.792856,27.861429,24.119560,88246200
2009-12-17,27.751429,27.857143,27.285715,27.408571,23.727531,97209700
2009-12-18,27.595715,27.928572,27.514286,27.918571,24.169037,152192600
2009-12-21,28.007143,28.535715,27.952858,28.318571,24.515310,152976600
2009-12-22,28.491428,28.692858,28.379999,28.622858,24.778732,87378900
2009-12-23,28.742857,28.911428,28.687143,28.871429,24.993919,86381400
2009-12-24,29.078571,29.907143,29.049999,29.862858,25.852201,125222300
2009-12-28,30.245714,30.564285,29.944286,30.230000,26.170031,161141400
2009-12-29,30.375713,30.388571,29.818571,29.871429,25.859617,111301400
2009-12-30,29.832857,30.285715,29.758572,30.234285,26.173737,103021100
2009-12-31,30.447144,30.478571,30.080000,30.104286,26.061205,88102700
2010-01-04,30.490000,30.642857,30.340000,30.572857,26.466835,123432400
2010-01-05,30.657143,30.798571,30.464285,30.625713,26.512596,150476200
2010-01-06,30.625713,30.747143,30.107143,30.138571,26.090879,138040000
2010-01-07,30.250000,30.285715,29.864286,30.082857,26.042646,119282800
2010-01-08,30.042856,30.285715,29.865715,30.282858,26.215786,111902700
2010-01-11,30.400000,30.428572,29.778572,30.015715,25.984528,115557400
2010-01-12,29.884285,29.967142,29.488571,29.674286,25.688946,148614900
2010-01-13,29.695715,30.132856,29.157143,30.092857,26.051304,151473000
2010-01-14,30.015715,30.065714,29.860001,29.918571,25.900436,108223500
2010-01-15,30.132856,30.228571,29.410000,29.418571,25.467583,148516900
2010-01-19,29.761429,30.741428,29.605715,30.719999,26.594227,182501900
2010-01-20,30.701429,30.792856,29.928572,30.247143,26.184870,153038200
2010-01-21,30.297142,30.472857,29.601429,29.724285,25.732233,152038600
2010-01-22,29.540001,29.642857,28.165714,28.250000,24.455948,220441900
2010-01-25,28.930000,29.242857,28.598572,29.010000,25.113882,266424900
2010-01-26,29.421429,30.530001,28.940001,29.420000,25.468813,466777500
2010-01-27,29.549999,30.082857,28.504286,29.697144,25.708735,430642100
2010-01-28,29.275715,29.357143,28.385714,28.469999,24.646406,293375600
2010-01-29,28.725714,28.885714,27.178572,27.437143,23.752270,311488100
2010-02-01,27.481428,28.000000,27.328571,27.818571,24.082464,187469100
2010-02-02,27.987143,28.045713,27.625713,27.980000,24.222212,174585600
2010-02-03,27.881428,28.600000,27.774286,28.461428,24.638979,153832000
2010-02-04,28.104286,28.338572,27.367144,27.435715,23.751026,189413000
2010-02-05,27.518572,28.000000,27.264286,27.922857,24.172745,212576700
2010-02-08,27.955715,28.268572,27.714285,27.731428,24.007027,119567700
2010-02-09,28.059999,28.214285,27.821428,28.027143,24.263025,158221700
2010-02-10,27.984285,28.085714,27.751429,27.874287,24.130701,92590400
2010-02-11,27.840000,28.535715,27.722857,28.381428,24.569729,137586400
2010-02-12,28.301428,28.805714,27.928572,28.625713,24.781204,163867200
2010-02-16,28.848572,29.098572,28.788572,29.057142,25.154692,135934400
2010-02-17,29.170000,29.187143,28.694286,28.935715,25.049570,109099200
2010-02-18,28.804285,29.127142,28.702858,28.990000,25.096561,105706300
2010-02-19,28.837143,29.028572,28.730000,28.809999,24.940742,103867400
2010-02-22,28.905714,28.928572,28.455715,28.631428,24.786160,97640900
2010-02-23,28.571428,28.761429,27.958570,28.151428,24.370621,143773700
2010-02-24,28.318571,28.777143,28.262857,28.665714,24.815836,115141600
2010-02-25,28.197144,28.980000,28.127142,28.857143,24.981554,166281500
2010-02-26,28.911428,29.309999,28.857143,29.231428,25.305573,126865200
2010-03-01,29.392857,29.928572,29.350000,29.855715,25.846012,137523400
2010-03-02,29.990000,30.118572,29.677143,29.835714,25.828703,141636600
2010-03-03,29.848572,29.981428,29.705715,29.904285,25.888062,93013200
2010-03-04,29.897142,30.131428,29.804285,30.101429,26.058725,91510300
2010-03-05,30.705715,31.385714,30.661428,31.278572,27.077780,224905100
2010-03-08,31.430000,31.441429,31.178572,31.297142,27.093855,107472400
2010-03-09,31.187143,32.142857,31.127142,31.860001,27.581120,230064800
2010-03-10,31.975714,32.211430,31.885714,32.119999,27.806202,149054500
2010-03-11,31.987143,32.214287,31.902857,32.214287,27.887825,101425100
2010-03-12,32.481430,32.532856,32.250000,32.371429,28.023863,104080900
2010-03-15,32.197144,32.214287,31.464285,31.977142,27.682528,123375700
2010-03-16,32.025715,32.139999,31.787144,32.064285,27.757971,111727000
2010-03-17,32.128571,32.349998,31.895714,32.017143,27.717154,112739200
2010-03-18,32.014286,32.142857,31.801428,32.092857,27.782703,85527400
2010-03-19,32.112858,32.177143,31.604286,31.750000,27.485895,139861400
2010-03-22,31.495714,32.285713,31.450001,32.107143,27.795071,114104900
2010-03-23,32.234287,32.682858,32.014286,32.622856,28.241524,150607800
2010-03-24,32.520000,32.885715,32.501427,32.767143,28.366425,149445100
2010-03-25,32.988571,32.995716,32.321430,32.378571,28.030043,135571100
2010-03-26,32.707142,33.135715,32.650002,32.985714,28.555645,160218800
2010-03-29,33.285713,33.410000,33.088570,33.198570,28.739906,135186100
2010-03-30,33.799999,33.925713,33.464287,33.692856,29.167816,131827500
2010-03-31,33.641430,33.801430,33.494286,33.571430,29.062700,107664900
2010-04-01,33.915714,34.104286,33.250000,33.709999,29.182661,150786300
2010-04-05,33.568573,34.072857,33.538570,34.070000,29.494308,171126900
2010-04-06,34.028572,34.320000,33.857143,34.220001,29.624166,111754300
2010-04-07,34.221428,34.560001,34.094284,34.371429,29.755251,157125500
2010-04-08,34.348572,34.505714,34.005714,34.278572,29.674870,143247300
2010-04-09,34.490002,34.555714,34.351429,34.541428,29.902428,83545700
2010-04-12,34.599998,34.724285,34.544285,34.612858,29.964258,83256600
2010-04-13,34.551430,34.685715,34.444286,34.632858,29.981571,76552700
2010-04-14,35.040001,35.115715,34.867142,35.098572,30.384733,101019100
2010-04-15,35.111427,35.575714,35.072857,35.560001,30.784204,94196200
2010-04-16,35.509998,35.877144,34.935715,35.342857,30.596218,187636400
2010-04-19,35.290001,35.412857,34.538570,35.295715,30.555408,141731100
2010-04-20,35.505714,35.607143,34.708572,34.941429,30.248701,184581600
2010-04-21,36.971428,37.178570,36.532856,37.031429,32.058018,245597800
2010-04-22,36.891430,38.107143,36.599998,38.067142,32.954624,198356200
2010-04-23,38.284286,38.882858,38.142857,38.689999,33.493832,199238900
2010-04-26,38.840000,38.922855,38.312859,38.500000,33.329353,119767200
2010-04-27,38.181427,38.262856,37.217144,37.434284,32.406757,177335900
2010-04-28,37.607143,37.714287,36.630001,37.371429,32.352356,189600600
2010-04-29,37.574287,38.571430,37.430000,38.377144,33.222996,139710200
2010-04-30,38.472858,38.652859,37.285713,37.298573,32.289265,135615900
2010-05-03,37.691429,38.268570,37.554287,38.049999,32.939774,113585500
2010-05-04,37.555714,37.612858,36.678570,36.954285,31.991230,180954900
2010-05-05,36.147144,36.877144,35.532856,36.570000,31.658550,220775800
2010-05-06,36.261429,36.892857,28.464285,35.178570,30.453995,321465200
2010-05-07,34.815716,35.224285,32.172855,33.694286,29.169060,419004600
2010-05-10,35.750000,36.378571,35.504284,36.284286,31.411213,246076600
2010-05-11,35.977142,37.127144,35.785713,36.645714,31.724100,212226700
2010-05-12,37.034286,37.590000,36.957142,37.441429,32.412945,163594900
2010-05-13,37.602856,37.857143,36.628571,36.908573,31.951658,149928100
2010-05-14,36.451427,36.639999,35.642857,36.259998,31.390186,189840700
2010-05-17,36.385715,36.597141,35.387142,36.317142,31.439657,190708700
2010-05-18,36.711430,36.935715,35.751427,36.051430,31.209614,195669600
2010-05-19,35.642857,36.131428,34.978573,35.477142,30.712471,256431700
2010-05-20,34.554287,34.835712,33.744286,33.965714,29.404034,320728800
2010-05-21,33.259998,34.928570,33.049999,34.617142,29.967972,305972800
2010-05-24,35.325714,35.842857,35.180000,35.251427,30.517067,188559700
2010-05-25,34.192856,35.251427,33.880001,35.031429,30.326622,262001600
2010-05-26,35.725716,36.018570,34.821430,34.872856,30.189339,212663500
2010-05-27,35.799999,36.270000,35.587143,36.192856,31.332062,166570600
2010-05-28,37.055714,37.057144,36.192856,36.697144,31.768623,203903700
2010-06-01,37.098572,37.991428,36.994286,37.261429,32.257130,219118200
2010-06-02,37.791428,37.828571,37.189999,37.707142,32.642975,172137000
2010-06-03,37.882858,37.935715,37.201427,37.588570,32.540325,162526700
2010-06-04,36.887142,37.414288,36.375713,36.565716,31.654835,189576100
2010-06-07,36.898571,37.021427,35.792858,35.848572,31.034019,221735500
2010-06-08,36.177143,36.257141,35.092857,35.618572,30.834908,250192600
2010-06-09,35.924286,35.985714,34.641430,34.742859,30.076796,213657500
2010-06-10,34.977142,35.854286,34.599998,35.787144,30.980843,194089000
2010-06-11,35.461430,36.265713,35.338570,36.215714,31.351847,136439800
2010-06-14,36.565716,37.021427,36.287144,36.325714,31.447088,150740100
2010-06-15,36.520000,37.121429,36.500000,37.098572,32.116135,146268500
2010-06-16,37.299999,38.250000,37.232857,38.178570,33.051083,195919500
2010-06-17,38.657143,38.985714,38.500000,38.838570,33.622452,218213800
2010-06-18,38.892857,39.285713,38.774284,39.152859,33.894520,196155400
2010-06-21,39.669998,39.858570,38.389999,38.595715,33.412212,194122600
2010-06-22,38.880001,39.424286,38.785713,39.121429,33.867310,179315500
2010-06-23,39.225716,39.237144,38.271427,38.709999,33.511150,192114300
2010-06-24,38.714287,39.028572,38.299999,38.428570,33.267521,178569300
2010-06-25,38.580002,38.610001,37.972858,38.099998,32.983074,137485600
2010-06-28,38.132858,38.535713,37.788570,38.328571,33.180943,146237000
2010-06-29,37.731430,37.770000,36.328571,36.595715,31.680811,283336200
2010-06-30,36.672855,36.852856,35.715714,35.932858,31.106989,184863000
2010-07-01,36.328571,36.400002,34.745716,35.497143,30.729792,255724000
2010-07-02,35.784286,35.847141,34.742859,35.277142,30.539333,173460700
2010-07-06,35.857143,36.114285,35.165714,35.518570,30.748335,153808900
2010-07-07,35.784286,36.967144,35.678570,36.952858,31.989985,163639000
2010-07-08,37.497143,37.557144,36.412857,36.869999,31.918266,184536100
2010-07-09,36.698570,37.128571,36.451427,37.088570,32.107479,108330600
2010-07-12,36.932858,37.407143,36.408573,36.755714,31.819332,140719600
2010-07-13,36.617142,36.628571,35.204285,35.971428,31.140364,297731000
2010-07-14,35.625713,36.542858,35.571430,36.104286,31.255392,203011900
2010-07-15,35.461430,36.709999,35.328571,35.921429,31.097084,206216500
2010-07-16,36.168571,36.424286,35.487144,35.700001,30.905407,259964600
2010-07-19,35.697144,35.697144,34.228573,35.082859,30.371145,256119500
2010-07-20,34.700001,36.128571,34.287144,35.984287,31.151503,268737700
2010-07-21,37.869999,37.878571,36.285713,36.320000,31.442122,296417800
2010-07-22,36.811428,37.142857,36.472858,37.002857,32.033283,161329700
2010-07-23,36.727142,37.197144,36.611427,37.134285,32.147045,133347200
2010-07-26,37.142857,37.157143,36.815716,37.040001,32.065430,105137900
2010-07-27,37.267143,37.828571,37.185715,37.725716,32.659046,146192900
2010-07-28,37.667141,37.998573,37.178570,37.279999,32.273190,129996300
2010-07-29,37.244286,37.521427,36.585712,36.872856,31.920740,160951700
2010-07-30,36.555714,37.099998,36.414288,36.750000,31.814383,112052500
2010-08-02,37.205715,37.512856,37.088570,37.407143,32.383263,107013900
2010-08-03,37.287144,37.608570,37.060001,37.418571,32.393154,104413400
2010-08-04,37.548573,37.754284,37.187141,37.568573,32.523029,105093800
2010-08-05,37.389999,37.597141,37.221428,37.385715,32.364719,72274300
2010-08-06,37.111427,37.355713,36.804287,37.155716,32.165604,111224400
2010-08-09,37.354286,37.450001,37.081429,37.392857,32.370895,75782000
2010-08-10,37.121429,37.207142,36.792858,37.058571,32.081516,112980000
2010-08-11,36.485714,36.527142,35.687141,35.741428,30.941259,155013600
2010-08-12,35.241428,36.157143,35.160000,35.970001,31.139137,133730100
2010-08-13,35.950001,35.982857,35.584286,35.585712,30.806463,88717300
2010-08-16,35.368572,35.715714,35.231430,35.377144,30.625906,79607500
2010-08-17,35.725716,36.375713,35.599998,35.995716,31.161400,105660100
2010-08-18,36.051430,36.381428,35.939999,36.152859,31.297430,84924000
2010-08-19,36.119999,36.211430,35.525715,35.697144,30.902927,106676500
2010-08-20,35.627144,36.274284,35.571430,35.662857,30.873240,96057500
2010-08-23,35.970001,36.000000,35.035713,35.114285,30.398338,103510400
2010-08-24,34.667141,34.714287,34.092857,34.275715,29.672398,150641400
2010-08-25,34.005714,34.855713,33.885715,34.698570,30.038467,149216900
2010-08-26,35.064285,35.107143,34.325714,34.325714,29.715677,116626300
2010-08-27,34.535713,34.658573,33.651428,34.517143,29.881397,137097800
2010-08-30,34.394287,35.107143,34.382858,34.642857,29.990227,95822300
2010-08-31,34.549999,34.937141,34.335712,34.728573,30.064436,105196700
2010-09-01,35.352856,35.922855,35.182858,35.761429,30.958572,174259400
2010-09-02,35.894287,36.024284,35.509998,36.024284,31.186125,103856900
2010-09-03,36.441429,36.968571,36.357143,36.967144,32.002354,130197200
2010-09-07,36.662857,37.075714,36.607143,36.830002,31.883636,85639400
2010-09-08,37.111427,37.770000,37.014286,37.560001,32.515610,131637800
2010-09-09,37.862858,38.074287,37.560001,37.581429,32.534145,109643800
2010-09-10,37.598572,37.785713,37.342857,37.630001,32.576195,96885600
2010-09-13,37.974285,38.325714,37.965714,38.148571,33.025120,97195000
2010-09-14,38.029999,38.452858,37.931427,38.294285,33.151253,102037600
2010-09-15,38.310001,38.625713,38.262856,38.602856,33.418404,107342200
2010-09-16,38.605713,39.524284,38.500000,39.509998,34.203705,163025800
2010-09-17,39.669998,39.708572,39.097141,39.338570,34.055305,158619300
2010-09-20,39.439999,40.540001,39.407143,40.461430,35.027351,164669400
2010-09-21,40.551430,41.049999,40.398571,40.538570,35.094143,167018600
2010-09-22,40.387142,41.139999,40.344284,41.107143,35.586349,146322400
2010-09-23,40.904285,41.822857,40.857143,41.274284,35.731030,196529200
2010-09-24,41.728573,41.932858,41.507141,41.759998,36.151516,162372000
2010-09-27,41.997143,42.104286,41.572857,41.594284,36.008068,120708700
2010-09-28,41.681427,41.681427,39.285713,40.980000,35.476269,258760600
2010-09-29,41.032856,41.401428,40.857143,41.052856,35.539349,117411000
2010-09-30,41.285713,41.428570,40.178570,40.535713,35.091660,168347900
2010-10-01,40.878571,40.939999,40.192856,40.360001,34.939545,112035700
2010-10-04,40.228573,40.414288,39.681427,39.805714,34.459702,108825500
2010-10-05,40.285713,41.349998,40.259998,41.277142,35.733513,125491800
2010-10-06,41.369999,41.712856,40.751427,41.312859,35.764439,167717200
2010-10-07,41.477142,41.497143,40.987144,41.317142,35.768143,102099900
2010-10-08,41.672855,42.071430,41.428570,42.009998,36.367954,164600800
2010-10-11,42.105713,42.462856,42.085712,42.194286,36.527481,106938300
2010-10-12,42.201427,42.785713,41.784286,42.648571,36.920757,139636000
2010-10-13,42.885715,43.137142,42.828571,42.877144,37.118629,157523100
2010-10-14,43.098572,43.209999,42.914288,43.187141,37.387001,108824100
2010-10-15,43.919998,45.000000,43.558571,44.962856,38.924232,230548500
2010-10-18,45.495716,45.571430,44.898571,45.428570,39.327400,273252700
2010-10-19,43.342857,44.824287,42.860001,44.212856,38.274960,308196000
2010-10-20,44.142857,44.892857,43.838570,44.361427,38.403580,180406100
2010-10-21,44.622856,44.962856,43.828571,44.217144,38.278667,137865000
2010-10-22,44.152859,44.291428,43.757141,43.924286,38.025139,93194500
2010-10-25,44.155716,44.514286,44.062859,44.119999,38.194569,98115500
2010-10-26,43.838570,44.248573,43.664288,44.007141,38.096863,98232400
2010-10-27,43.950001,44.271427,43.657143,43.975716,38.069653,99750700
2010-10-28,43.992859,44.000000,42.985714,43.605713,37.749355,137762800
2010-10-29,43.461430,43.697144,42.981430,42.997143,37.222515,107627800
2010-11-01,43.174286,43.657143,43.171429,43.454285,37.618259,105972300
2010-11-02,43.857143,44.312859,43.857143,44.194286,38.258869,108482500
2010-11-03,44.481430,44.697144,44.075714,44.685715,38.684299,127087100
2010-11-04,45.064285,45.740002,45.004284,45.467144,39.360783,160622000
2010-11-05,45.427143,45.652859,45.250000,45.304287,39.219810,90313300
2010-11-08,45.314285,45.681427,45.251427,45.517143,39.404072,70439600
2010-11-09,45.864285,45.900002,44.928570,45.154285,39.089947,95886000
2010-11-10,45.234287,45.538570,44.792858,45.432858,39.331104,96056800
2010-11-11,45.000000,45.485714,44.892857,45.235714,39.160442,90321000
2010-11-12,45.142857,45.214287,43.375713,44.004284,38.094391,198961700
2010-11-15,44.065716,44.362858,43.752857,43.862858,37.971966,100901500
2010-11-16,43.674286,43.942856,42.759998,43.084286,37.297951,164412500
2010-11-17,43.028572,43.427143,42.537144,42.928570,37.163139,119862400
2010-11-18,43.599998,44.238571,43.527142,44.061428,38.143871,123622800
2010-11-19,43.995716,44.057144,43.605713,43.818573,37.933628,96210800
2010-11-22,43.811428,44.765713,43.695713,44.765713,38.753555,98268800
2010-11-23,44.349998,44.535713,43.794285,44.104286,38.180965,129861900
2010-11-24,44.571430,45.057144,44.535713,44.971428,38.931641,103431300
2010-11-26,44.820000,45.385715,44.705715,45.000000,38.956387,59396400
2010-11-29,45.071430,45.354286,44.482857,45.267143,39.187645,111446300
2010-11-30,44.791428,44.908573,44.410000,44.450001,38.480263,125464500
2010-12-01,45.038570,45.392857,45.000000,45.200001,39.129532,115437700
2010-12-02,45.361427,45.571430,44.984287,45.450001,39.345947,115709300
2010-12-03,45.287144,45.521427,45.191429,45.348572,39.258148,85523200
2010-12-06,45.520000,46.047142,45.488571,45.735714,39.593285,112120400
2010-12-07,46.257141,46.284286,45.445713,45.458572,39.353374,97863500
2010-12-08,45.661430,45.860001,45.301430,45.858570,39.699638,80483900
2010-12-09,46.018570,46.071430,45.574287,45.680000,39.545059,73537800
2010-12-10,45.664288,45.864285,45.514286,45.794285,39.643997,65627800
2010-12-13,46.338570,46.437141,45.857143,45.952858,39.781277,109953900
2010-12-14,45.961430,46.077145,45.571430,45.755714,39.610603,87752000
2010-12-15,45.714287,46.142857,45.598572,45.765713,39.619251,104328000
2010-12-16,45.869999,46.087143,45.728573,45.892857,39.729332,80507700
2010-12-17,45.947144,45.970001,45.747143,45.801430,39.650185,96732300
2010-12-20,45.942856,46.178570,45.461430,46.029999,39.848045,96402600
2010-12-21,46.142857,46.341427,46.007141,46.314285,40.094151,64088500
2010-12-22,46.337143,46.531429,46.221428,46.451427,40.212875,66480400
2010-12-23,46.428570,46.450001,46.167141,46.228573,40.019943,55789300
2010-12-27,46.121429,46.491428,45.931427,46.382858,40.153526,62454000
2010-12-28,46.558571,46.665714,46.437141,46.495716,40.251225,43981000
2010-12-29,46.602856,46.635715,46.442856,46.470001,40.228962,40784800
2010-12-30,46.497143,46.501427,46.150002,46.237144,40.027370,39373600
2010-12-31,46.135715,46.211430,45.901428,46.080002,39.891342,48377000
2011-01-03,46.520000,47.180000,46.405716,47.081429,40.758278,111284600
2011-01-04,47.491428,47.500000,46.878571,47.327145,40.970993,77270200
2011-01-05,47.078571,47.762856,47.071430,47.714287,41.306126,63879900
2011-01-06,47.817142,47.892857,47.557144,47.675713,41.272743,75107200
2011-01-07,47.712856,48.049999,47.414288,48.017143,41.568314,77982800
2011-01-10,48.404285,49.032856,48.167141,48.921429,42.351151,112140000
2011-01-11,49.268570,49.279999,48.495716,48.805714,42.250977,111027000
2011-01-12,49.035713,49.204285,48.857143,49.202858,42.594788,75647600
2011-01-13,49.308571,49.520000,49.121429,49.382858,42.750610,74195100
2011-01-14,49.412857,49.782856,49.205715,49.782856,43.096882,77210000
2011-01-18,47.074287,49.251427,46.571430,48.664288,42.128551,470249500
2011-01-19,49.764286,49.799999,48.125713,48.405716,41.904705,283903200
2011-01-20,48.061428,48.328571,47.160000,47.525715,41.142883,191197300
2011-01-21,47.681427,47.840000,46.661430,46.674286,40.405804,188600300
2011-01-24,46.695713,48.207142,46.674286,48.207142,41.732792,143670800
2011-01-25,48.047142,48.777142,47.795715,48.771427,42.221302,136717000
2011-01-26,48.994286,49.371429,48.785713,49.121429,42.524296,126718900
2011-01-27,49.111427,49.241428,48.975716,49.029999,42.445145,71256500
2011-01-28,49.167141,49.200001,47.647144,48.014286,41.565842,148014300
2011-01-31,47.971428,48.577145,47.757141,48.474285,41.964069,94311700
2011-02-01,48.757141,49.378571,48.711430,49.290001,42.670216,106658300
2011-02-02,49.207142,49.321430,49.078571,49.188572,42.582420,64738800
2011-02-03,49.114285,49.177143,48.364285,49.062859,42.473591,98449400
2011-02-04,49.091427,49.528572,49.072857,49.500000,42.852013,80460100
2011-02-07,49.698570,50.464287,49.662857,50.268570,43.517361,121255400
2011-02-08,50.525715,50.788570,50.307144,50.742859,43.927963,95260200
2011-02-09,50.741428,51.285713,50.695713,51.165714,44.294018,120686300
2011-02-10,51.055714,51.428570,49.714287,50.648571,43.846340,232137500
2011-02-11,50.678570,51.114285,50.505714,50.978573,44.132027,91893200
2011-02-14,50.970001,51.354286,50.958572,51.311428,44.420162,77604100
2011-02-15,51.312859,51.424286,51.078571,51.414288,44.509216,71043700
2011-02-16,51.542858,52.128571,51.500000,51.875713,44.908665,120289400
2011-02-17,51.035713,51.467144,50.931427,51.185715,44.311333,132645800
2011-02-18,51.244286,51.357143,49.931427,50.080002,43.354118,204014300
2011-02-22,48.878571,49.342857,48.245716,48.372856,41.876259,218138900
2011-02-23,48.395714,49.234287,48.372856,48.945713,42.372185,167963600
2011-02-24,49.145714,49.307144,48.338570,48.982857,42.404331,124975200
2011-02-25,49.322857,49.775715,49.257141,49.737144,43.057316,95004700
2011-02-28,50.177143,50.721428,50.160000,50.458572,43.681858,100768500
2011-03-01,50.781429,50.817142,49.668571,49.901428,43.199551,114034200
2011-03-02,49.994286,50.621429,49.771427,50.302856,43.547050,150647700
2011-03-03,51.027142,51.398571,50.845715,51.365715,44.467155,125197100
2011-03-04,51.438572,51.470001,51.107143,51.428570,44.521584,113316700
2011-03-07,51.628571,51.667141,50.187141,50.765713,43.947746,136530800
2011-03-08,50.701427,51.057144,50.321430,50.822857,43.997223,89079200
2011-03-09,50.669998,50.680000,50.085712,50.352856,43.590332,113326500
2011-03-10,49.874287,49.967144,49.271427,49.524284,42.873047,126884800
2011-03-11,49.332859,50.331429,49.285713,50.284286,43.530972,117770100
2011-03-14,50.454285,50.925713,50.187141,50.508572,43.725136,108989300
2011-03-15,48.871429,49.691429,48.585712,49.347141,42.719685,180270300
2011-03-16,48.857143,49.000000,46.608570,47.144287,40.812687,290502800
2011-03-17,48.118572,48.515713,47.237144,47.805714,41.385277,164855600
2011-03-18,48.161430,48.314285,47.142857,47.238571,40.894302,188303500
2011-03-21,47.998573,48.534286,47.894287,48.471428,41.961586,102350500
2011-03-22,48.937141,48.945713,48.448570,48.742859,42.196568,81480700
2011-03-23,48.468571,48.602856,47.992859,48.455715,41.947987,93249100
2011-03-24,48.835712,49.428570,48.408573,49.281429,42.662811,101178000
2011-03-25,49.724285,50.294285,49.574287,50.220001,43.475327,112227500
2011-03-28,50.450001,50.617142,50.062859,50.062859,43.339283,77338800
2011-03-29,49.665714,50.137142,49.437141,50.137142,43.403591,88225200
2011-03-30,50.091427,50.125713,49.634285,49.804287,43.115456,82351500
2011-03-31,49.480000,49.971428,49.437141,49.787144,43.100601,68504800
2011-04-01,50.158573,50.227142,49.042858,49.222858,42.612103,104665400
2011-04-04,49.187141,49.228573,48.342857,48.741428,42.195332,115021200
2011-04-05,48.141430,48.892857,48.000000,48.412857,41.910877,120682800
2011-04-06,48.745716,49.128571,48.162857,48.291428,41.805752,100634800
2011-04-07,48.299999,48.632858,48.004284,48.297142,41.810707,93361800
2011-04-08,48.560001,48.592857,47.707142,47.865715,41.437222,94383800
2011-04-11,47.722858,47.952858,47.145714,47.257141,40.910381,99736700
2011-04-12,47.212856,47.675713,47.171429,47.485714,41.108269,106409800
2011-04-13,47.860001,48.020000,47.502857,48.018570,41.569561,86555000
2011-04-14,47.828571,48.000000,47.437141,47.488571,41.110729,75450200
2011-04-15,47.614285,47.662857,46.685715,46.779999,40.497334,113401400
2011-04-18,46.585712,47.461430,45.737144,47.407143,41.040241,152474700
2011-04-19,47.585712,48.282856,47.387142,48.265713,41.783489,104844600
2011-04-20,49.072857,49.392857,48.785713,48.915714,42.346214,175166600
2011-04-21,50.714287,50.732857,49.788570,50.099998,43.371437,188452600
2011-04-25,50.048573,50.535713,50.042858,50.430000,43.657127,66636500
2011-04-26,50.517143,50.712856,49.907143,50.060001,43.336811,84700000
2011-04-27,50.320000,50.335712,49.585712,50.021427,43.303425,89053300
2011-04-28,49.455715,49.964287,49.360001,49.535713,42.882938,90239800
2011-04-29,49.540001,50.564285,49.524284,50.018570,43.300945,251586300
2011-05-02,49.962856,50.067142,49.357143,49.468571,42.824818,110678400
2011-05-03,49.712856,49.984287,49.374287,49.742859,43.062275,78337000
2011-05-04,49.751427,50.261429,49.554287,49.938572,43.231686,97312600
2011-05-05,49.771427,50.135715,49.435715,49.535713,42.882938,83992300
2011-05-06,49.955715,50.000000,49.458572,49.522858,42.871822,70033600
2011-05-09,49.694286,49.885715,49.504284,49.657143,42.988056,51186800
2011-05-10,49.841427,49.955715,49.522858,49.921429,43.216854,70522900
2011-05-11,49.860001,50.000000,49.320000,49.604286,42.942310,84000000
2011-05-12,49.445713,49.588570,48.895714,49.509998,42.860680,80500000
2011-05-13,49.380001,49.464287,48.621429,48.642857,42.109985,81529000
2011-05-16,48.457142,48.745716,47.514286,47.614285,41.219566,112443800
2011-05-17,47.428570,48.020000,47.247143,48.020000,41.570786,113083600
2011-05-18,48.067142,48.721428,48.000000,48.552856,42.032082,83694100
2011-05-19,48.868572,48.915714,48.381428,48.647144,42.113697,65292500
2011-05-20,48.508572,48.707142,47.860001,47.888573,41.457008,84492100
2011-05-23,47.138573,47.997143,47.060001,47.771427,41.355602,95900000
2011-05-24,47.928570,47.985714,47.334286,47.455715,41.082294,80481800
2011-05-25,47.632858,48.365715,47.549999,48.111427,41.649929,73556000
2011-05-26,47.995716,48.127144,47.775715,47.857143,41.429794,55640200
2011-05-27,47.828571,48.232857,47.758572,48.201427,41.727859,50899800
2011-05-31,48.728573,49.689999,48.714287,49.689999,43.016495,104438600
2011-06-01,49.838570,50.304287,49.235714,49.358570,42.729584,138670700
2011-06-02,49.500000,49.711430,49.185715,49.442856,42.802540,84695800
2011-06-03,49.025715,49.332859,48.858570,49.062859,42.473591,78312500
2011-06-06,49.385715,49.578571,48.258572,48.291428,41.805752,115485300
2011-06-07,48.310001,48.317142,47.414288,47.434284,41.063732,132446300
2011-06-08,47.397144,47.828571,47.235714,47.462856,41.088474,83430900
2011-06-09,47.607143,47.667141,47.250000,47.355713,40.995716,68772200
2011-06-10,47.221428,47.380001,46.501427,46.557144,40.304398,108488800
2011-06-13,46.742859,46.901428,46.438572,46.657143,40.390961,82368300
2011-06-14,47.142857,47.607143,47.044285,47.491428,41.113205,83642300
2011-06-15,47.107143,47.185715,46.411430,46.678570,40.409512,99799000
2011-06-16,46.700001,46.954285,45.475716,46.451427,40.212875,127647800
2011-06-17,46.998573,47.035713,45.622856,45.751427,39.606884,153755000
2011-06-20,45.337143,45.385715,44.357143,45.045715,38.995956,160161400
2011-06-21,45.240002,46.542858,45.028572,46.471428,40.230194,123345600
2011-06-22,46.451427,46.985714,46.054287,46.087143,39.897514,97645800
2011-06-23,45.562859,47.384285,45.445713,47.318573,40.963558,139939800
2011-06-24,47.338570,47.592857,46.441429,46.621429,40.360050,109951800
2011-06-27,46.798573,47.700001,46.750000,47.434284,41.063732,84953400
2011-06-28,47.664288,48.099998,47.634285,47.894287,41.461960,73574900
2011-06-29,48.005714,48.052856,47.411430,47.720001,41.311077,88136300
2011-06-30,47.814285,48.018570,47.548573,47.952858,41.512661,80738700
2011-07-01,47.992859,49.071430,47.742859,49.037144,42.451332,108828300
2011-07-05,49.000000,49.975716,48.928570,49.918571,43.214375,88763500
2011-07-06,49.849998,50.585712,49.529999,50.251427,43.502525,111156500
2011-07-07,50.667141,51.142857,50.571430,51.028572,44.175301,99915900
2011-07-08,50.477142,51.428570,50.314285,51.387142,44.485714,122408300
2011-07-11,50.905716,51.395714,50.402859,50.571430,43.779568,110668600
2011-07-12,50.504284,51.097141,49.802856,50.535713,43.748634,112902300
2011-07-13,51.189999,51.428570,50.911430,51.145714,44.276707,97909700
2011-07-14,51.572857,51.658573,50.905716,51.110001,44.245792,107633400
2011-07-15,51.595715,52.142857,51.310001,52.131428,45.130054,121116800
2011-07-18,52.204285,53.521427,52.182858,53.400002,46.228241,143163300
2011-07-19,54.000000,54.092857,53.331429,53.835712,46.605438,204786400
2011-07-20,56.588570,56.610001,55.142857,55.271427,47.848339,235335100
2011-07-21,55.278572,55.722858,54.842857,55.327145,47.896568,131633600
2011-07-22,55.474285,56.435715,55.392857,56.185715,48.639839,129182200
2011-07-25,55.764286,57.142857,55.660000,56.928570,49.282921,147451500
2011-07-26,57.142857,57.785713,57.097141,57.630001,49.890137,119145600
2011-07-27,57.227142,57.520000,56.021427,56.084286,48.552017,164831100
2011-07-28,55.945713,56.712856,55.447144,55.974285,48.456799,148508500
2011-07-29,55.377144,56.450001,54.857143,55.782856,48.291065,158146100
2011-08-01,56.825714,57.071430,56.052856,56.678570,49.066498,153209000
2011-08-02,56.807144,56.842857,55.478573,55.558571,48.096912,159884900
2011-08-03,55.854286,56.221428,54.605713,56.081429,48.549541,183127000
2011-08-04,55.630001,55.902859,53.907143,53.910000,46.669743,217851900
2011-08-05,54.348572,54.785713,51.795715,53.374287,46.205975,301147700
2011-08-08,51.669998,52.538570,50.431427,50.458572,43.681858,285958400
2011-08-09,51.614285,53.515713,50.714287,53.430000,46.254219,270645900
2011-08-10,53.021427,53.521427,51.785713,51.955715,44.977917,219664200
2011-08-11,52.931427,53.635715,52.102856,53.385715,46.215874,185492300
2011-08-12,54.009998,54.234287,53.461430,53.855713,46.622749,132244000
2011-08-15,54.232857,54.995716,54.012856,54.772858,47.416718,115136000
2011-08-16,54.502857,54.767143,53.722858,54.354286,47.054371,124687500
2011-08-17,54.615715,54.931427,54.000000,54.348572,47.049416,110515300
2011-08-18,52.977142,53.235714,51.624287,52.292858,45.269787,212858800
2011-08-19,51.738571,52.428570,50.857143,50.861427,44.030621,193972100
2011-08-22,52.072857,52.125713,50.727142,50.919998,44.081306,133828800
2011-08-23,51.471428,53.377144,51.000000,53.371429,46.203510,164208800
2011-08-24,53.352856,54.137142,52.942856,53.740002,46.522579,156566900
2011-08-25,52.154285,53.635715,52.142857,53.388573,46.218342,217836500
2011-08-26,53.024284,54.828571,52.971428,54.797142,47.437740,160369300
2011-08-29,55.454285,55.928570,55.428570,55.709999,48.227997,101317300
2011-08-30,55.464287,55.977142,55.172855,55.712856,48.230480,104480600
2011-08-31,55.795715,56.011429,54.551430,54.975716,47.592335,130646600
2011-09-01,55.117142,55.334286,54.388573,54.432858,47.122391,85931300
2011-09-02,53.534286,54.000000,53.118572,53.435715,46.259155,109734800
2011-09-06,52.481430,54.332859,52.354286,54.248573,46.962841,127424500
2011-09-07,55.080002,55.085712,54.571430,54.847141,47.481033,87644200
2011-09-08,54.628571,55.515713,54.615715,54.877144,47.507008,104039600
2011-09-09,54.847141,55.142857,53.574287,53.925713,46.683350,141203300
2011-09-12,53.285713,54.411430,53.128571,54.277142,46.987572,116958100
2011-09-13,54.591427,55.172855,54.321430,54.945713,47.566364,110140100
2011-09-14,55.288570,56.029999,55.108570,55.614285,48.145142,133681100
2011-09-15,55.918571,56.237144,55.700001,56.137142,48.597790,104454700
2011-09-16,56.505714,57.214287,56.432858,57.214287,49.530254,174628300
2011-09-19,56.714287,59.032856,56.457142,58.804287,50.906712,205965200
2011-09-20,59.321430,60.408573,58.741428,59.064285,51.131794,193938500
2011-09-21,59.948570,60.227142,58.857143,58.877144,50.969795,151494000
2011-09-22,57.290001,58.545715,56.671429,57.402859,49.693508,242120200
2011-09-23,57.182858,58.105713,57.121429,57.757141,50.000210,136569300
2011-09-26,57.122856,57.711430,55.900002,57.595715,49.860462,203219100
2011-09-27,58.389999,58.464287,56.865715,57.037144,49.376900,158124400
2011-09-28,57.169998,57.677143,56.644287,56.715714,49.098644,107409400
2011-09-29,57.417141,57.458572,55.172855,55.795715,48.302200,162771700
2011-09-30,55.302856,55.555714,54.454285,54.474285,47.158245,136910200
2011-10-03,54.338570,54.662857,53.310001,53.514286,46.327175,167274800
2011-10-04,53.509998,54.542858,50.605713,53.214287,46.067471,308419300
2011-10-05,52.551430,54.259998,51.471428,54.035713,46.778584,196617400
2011-10-06,53.332859,54.968571,53.114285,53.910000,46.669743,203145600
2011-10-07,53.682858,53.962856,52.641430,52.828571,45.733555,133864500
2011-10-10,54.155716,55.544285,54.029999,55.544285,48.084549,110628700
2011-10-11,56.081429,57.597141,55.928570,57.184284,49.504288,151421900
2011-10-12,58.191429,58.464287,57.162857,57.455715,49.739258,155571500
2011-10-13,57.854286,58.347141,57.549999,58.347141,50.510963,106546300
2011-10-14,59.547142,60.285713,59.324287,60.285713,52.189182,143341800
2011-10-17,60.248573,60.957142,59.419998,59.998573,51.940617,171511200
2011-10-18,60.251427,60.687141,59.427143,60.320000,52.218872,220400600
2011-10-19,57.335712,58.345715,56.828571,56.945713,49.297752,276014900
2011-10-20,57.142857,57.192856,56.315716,56.472858,48.888390,137317600
2011-10-21,56.871429,57.020000,55.821430,56.124287,48.586658,155311100
2011-10-24,56.597141,58.071430,56.485714,57.967144,50.182007,125534500
2011-10-25,57.861427,58.078571,56.768570,56.824287,49.192642,107606800
2011-10-26,57.394287,57.507141,56.164288,57.228573,49.542629,114076200
2011-10-27,58.222858,58.428570,57.412857,57.812859,50.048447,123666200
2011-10-28,57.571430,58.049999,57.501427,57.849998,50.080601,80710700
2011-10-31,57.488571,58.475716,57.292858,57.825714,50.059574,96375300
2011-11-01,56.772858,57.071430,56.174286,56.644287,49.036808,132947500
2011-11-02,57.155716,57.205715,56.444286,56.772858,49.148113,81837700
2011-11-03,57.009998,57.628571,56.480000,57.581429,49.848099,110346600
2011-11-04,57.432858,57.634285,57.022858,57.177143,49.498108,75557300
2011-11-07,57.130001,57.142857,56.590000,57.104286,49.435020,67568900
2011-11-08,57.458572,58.285713,57.365715,58.032856,50.238895,100110500
2011-11-09,56.709999,57.270000,56.318573,56.468571,48.884686,139671000
2011-11-10,56.718571,56.744286,54.592857,55.031429,47.640560,186188100
2011-11-11,55.230000,55.528572,54.322857,54.945713,47.566364,163446500
2011-11-14,54.788570,55.035713,54.028572,54.180000,46.903492,108226300
2011-11-15,54.400002,55.642857,54.207142,55.547142,48.087025,107702700
2011-11-16,55.607143,55.877144,54.902859,54.967144,47.584904,87302600
2011-11-17,54.854286,54.939999,53.642857,53.915714,46.674698,119975100
2011-11-18,54.131428,54.284286,53.554287,53.562859,46.369225,92984500
2011-11-21,52.914288,53.097141,52.272858,52.715714,45.635864,111995100
2011-11-22,53.002857,53.990002,52.991428,53.787144,46.563393,102255300
2011-11-23,53.501427,53.691429,52.411430,52.427143,45.386036,107067800
2011-11-25,52.631428,53.021427,51.902859,51.938572,44.963081,63690200
2011-11-28,53.192856,53.817142,52.904285,53.731430,46.515156,86603300
2011-11-29,53.691429,54.118572,52.885715,53.314285,46.154041,93963800
2011-11-30,54.470001,54.611427,54.042858,54.599998,47.267067,101484600
2011-12-01,54.648571,55.571430,54.392857,55.418571,47.975708,96795300
2011-12-02,55.689999,56.232857,55.511429,55.671429,48.194618,94763900
2011-12-05,56.212856,56.630001,55.770000,56.144287,48.603958,89302500
2011-12-06,56.072857,56.375713,55.625713,55.849998,48.349205,70899500
2011-12-07,55.704285,55.848572,55.251427,55.584286,48.119171,76186600
2011-12-08,55.921429,56.500000,55.747143,55.808571,48.313335,94089100
2011-12-09,56.121429,56.291428,55.861427,56.231430,48.679405,74248300
2011-12-12,55.954285,56.271427,55.635715,55.977142,48.459263,75266800
2011-12-13,56.142857,56.485714,55.299999,55.544285,48.084549,84732200
2011-12-14,55.242859,55.340000,53.954285,54.312859,47.018505,101721900
2011-12-15,54.761429,54.820000,54.044285,54.134285,46.863922,64050000
2011-12-16,54.337143,54.878571,54.224285,54.431427,47.121143,105369600
2011-12-19,54.638573,54.978573,54.354286,54.601429,47.268322,58882600
2011-12-20,55.394287,56.585712,55.322857,56.564285,48.967567,84303800
2011-12-21,56.669998,56.757141,56.001427,56.635715,49.029400,65737000
2011-12-22,56.714287,57.018570,56.585712,56.935715,49.289097,50589700
2011-12-23,57.098572,57.655716,57.070000,57.618572,49.880241,67349800
2011-12-27,57.585712,58.441429,57.574287,58.075714,50.275993,66269000
2011-12-28,58.127144,58.321430,57.334286,57.520000,49.794914,57165500
2011-12-29,57.628571,57.950001,57.215714,57.874287,50.101627,53994500
2011-12-30,57.644287,58.040001,57.641430,57.857143,50.086784,44915500
2012-01-03,58.485714,58.928570,58.428570,58.747143,50.857235,75555200
2012-01-04,58.571430,59.240002,58.468571,59.062859,51.130558,65005500
2012-01-05,59.278572,59.792858,58.952858,59.718571,51.698215,67817400
2012-01-06,59.967144,60.392857,59.888573,60.342857,52.238651,79573200
2012-01-09,60.785713,61.107143,60.192856,60.247143,52.155792,98506100
2012-01-10,60.844284,60.857143,60.214287,60.462856,52.342537,64549100
2012-01-11,60.382858,60.407143,59.901428,60.364285,52.257195,53771200
2012-01-12,60.325714,60.414288,59.821430,60.198570,52.113747,53146800
2012-01-13,59.957142,60.064285,59.808571,59.972858,51.918343,56505400
2012-01-17,60.599998,60.855713,60.422855,60.671429,52.523098,60724300
2012-01-18,60.994286,61.352856,60.900002,61.301430,53.068489,69197800
2012-01-19,61.450001,61.624287,60.930000,61.107143,52.900303,65434600
2012-01-20,61.070000,61.071430,59.964287,60.042858,51.978935,103493600
2012-01-23,60.381428,61.207142,60.328571,61.058571,52.858246,76515600
2012-01-24,60.728573,60.728573,59.935715,60.058571,51.992550,136909500
2012-01-25,64.919998,64.921425,63.389999,63.808571,55.238914,239578500
2012-01-26,64.051430,64.112854,63.305714,63.518570,54.987858,80996300
2012-01-27,63.477142,64.068573,63.395714,63.897144,55.315582,74927300
2012-01-30,63.672855,64.842857,63.627144,64.715714,56.024223,94835300
2012-01-31,65.084282,65.462860,64.724289,65.211426,56.453358,97920900
2012-02-01,65.487144,65.570000,65.078575,65.169998,56.417503,67511500
2012-02-02,65.128571,65.309998,64.854286,65.017143,56.285168,46699100
2012-02-03,65.328575,65.714287,65.080002,65.668571,56.849113,71649900
2012-02-06,65.482857,66.425713,65.457146,66.281425,57.379662,62353200
2012-02-07,66.464287,67.107140,66.368568,66.975716,57.980694,79055900
2012-02-08,67.214287,68.112854,67.099998,68.097145,58.951500,101972500
2012-02-09,68.680000,70.964287,68.651428,70.452858,60.990883,221053700
2012-02-10,70.137146,71.088570,69.792854,70.488571,61.021763,157825500
2012-02-13,71.361427,71.975716,71.012856,71.800003,62.157066,129304000
2012-02-14,72.094284,72.794289,71.714287,72.779999,63.005447,115099600
2012-02-15,73.465714,75.184288,70.984283,71.095711,61.547375,376530000
2012-02-16,70.214287,72.127144,69.518570,71.744286,62.108814,236138000
2012-02-17,71.872856,72.538574,71.471428,71.731430,62.097710,133951300
2012-02-21,72.411430,73.550003,72.017143,73.550003,63.672047,151398800
2012-02-22,73.297142,73.641426,72.724289,73.291428,63.448200,120825600
2012-02-23,73.582855,73.975716,72.785713,73.769997,63.862495,142006900
2012-02-24,74.238571,74.699997,74.091431,74.629997,64.607010,103768000
2012-02-27,74.472855,75.500000,73.754288,75.108574,65.021309,136895500
2012-02-28,75.422859,76.487144,75.121429,76.487144,66.214722,150096800
2012-02-29,77.365715,78.230003,76.528572,77.491432,67.084114,238002800
2012-03-01,78.309998,78.315712,76.967140,77.781425,67.335175,170817500
2012-03-02,77.748573,78.114288,77.502853,77.882858,67.422981,107928100
2012-03-05,77.917145,78.211426,75.142860,76.165718,65.936470,202281100
2012-03-06,74.808571,76.241432,73.745712,75.751427,65.577812,202559700
2012-03-07,76.685715,76.825714,74.757141,75.812859,65.630989,199630200
2012-03-08,76.384285,77.570000,76.017143,77.427139,67.028465,129114300
2012-03-09,77.744286,78.248573,77.587143,77.881432,67.421776,104729800
2012-03-12,78.425713,78.857140,78.142860,78.857140,68.266411,101820600
2012-03-13,79.648575,81.168571,79.392860,81.157143,70.257507,172713800
2012-03-14,82.578575,84.959999,82.199997,84.225716,72.913986,354711000
2012-03-15,85.658569,85.715714,82.650002,83.651428,72.416817,289929500
2012-03-16,83.531425,84.171425,82.571426,83.652855,72.418053,206371900
2012-03-19,85.481430,85.967140,84.150002,85.871429,74.338669,225309000
2012-03-20,85.644287,86.699997,84.497147,86.565712,74.939705,204165500
2012-03-21,86.105713,87.092857,85.915718,86.071426,74.511810,161010500
2012-03-22,85.397141,86.357140,85.075714,85.620003,74.121017,155967700
2012-03-23,85.784286,85.971428,84.914284,85.150002,73.714111,107622200
2012-03-26,85.684288,86.735718,85.037140,86.711426,75.065872,148935500
2012-03-27,86.597145,88.040001,86.580002,87.782860,75.993385,151782400
2012-03-28,88.339996,88.778572,87.187141,88.231430,76.381721,163865100
2012-03-29,87.540001,88.080002,86.747147,87.122856,75.422028,152059600
2012-03-30,86.967140,87.222855,85.419998,85.650002,74.146996,182759500
2012-04-02,85.975716,88.395714,85.768570,88.375717,76.506630,149587900
2012-04-03,89.614288,90.315712,88.930000,89.902855,77.828667,208639900
2012-04-04,89.192856,89.408569,88.142860,89.187141,77.209068,143245200
2012-04-05,89.568573,90.665718,89.057144,90.525711,78.367867,160324500
2012-04-09,89.447144,91.405716,89.328575,90.889999,78.683235,149384200
2012-04-10,91.418571,92.000000,89.428574,89.777145,77.719849,222431300
2012-04-11,90.885712,90.981430,89.048569,89.457146,77.442818,174153700
2012-04-12,89.285713,90.190002,88.642860,88.967140,77.018639,153584200
2012-04-13,89.158569,89.242859,86.215714,86.461426,74.849457,214911200
2012-04-16,87.151428,87.182854,82.607140,82.875717,71.745285,262696700
2012-04-17,82.705711,87.142860,81.701431,87.099998,75.402229,256382000
2012-04-18,87.674286,88.607140,86.101425,86.905716,75.234032,238632800
2012-04-19,85.745712,86.389999,83.502853,83.919998,72.649338,208679800
2012-04-20,84.482857,84.945717,81.488571,81.854286,70.861046,257746300
2012-04-23,81.515717,82.381432,79.517143,81.671425,70.702736,241632300
2012-04-24,80.372856,81.098572,79.285713,80.040001,69.290413,269037300
2012-04-25,87.948570,88.285713,86.571426,87.142860,75.439346,226444400
2012-04-26,87.752853,87.812859,86.018570,86.814285,75.154900,134017100
2012-04-27,86.438568,86.597145,85.785713,86.142860,74.573639,101680600
2012-04-30,85.400002,85.485718,83.285713,83.425713,72.221428,126536200
2012-05-01,83.557144,85.251427,83.032860,83.161430,71.992630,152749800
2012-05-02,82.891426,83.914284,82.694283,83.711426,72.468765,106847300
2012-05-03,84.357140,84.485718,82.900002,83.117142,71.954292,97637400
2012-05-04,82.440002,82.622856,80.738571,80.750000,69.905052,132498100
2012-05-07,80.214287,81.824287,80.175713,81.354286,70.428207,115029600
2012-05-08,81.368568,81.642860,79.818573,81.168571,70.267410,124313000
2012-05-09,80.528572,81.997147,80.121429,81.311432,70.391090,120176000
2012-05-10,82.082855,82.268570,81.205711,81.502853,70.556816,83300000
2012-05-11,80.714287,82.067146,80.621429,80.958572,70.085617,99886500
2012-05-14,80.367142,81.072861,79.657143,79.745712,69.035660,88156600
2012-05-15,80.207146,80.459999,78.821426,79.024284,68.411110,119084000
2012-05-16,79.150002,79.555717,77.291428,78.011429,67.534286,140224000
2012-05-17,77.901428,78.214287,75.731430,75.731430,65.560509,179305000
2012-05-18,76.279999,77.629997,74.597145,75.768570,65.592659,183073100
2012-05-21,76.357140,80.220001,76.292854,80.182854,69.414101,157776500
2012-05-22,81.364288,81.982857,78.940002,79.567146,68.881065,173717600
2012-05-23,79.642860,81.828575,79.032860,81.508568,70.561768,146224400
2012-05-24,82.267143,82.357140,80.175713,80.760002,69.913734,124057500
2012-05-25,80.655716,80.835716,79.781425,80.327141,69.538994,82126800
2012-05-29,81.557144,82.000000,80.758568,81.752853,70.773254,95127200
2012-05-30,81.314285,82.855713,80.937141,82.738571,71.626579,132357400
2012-05-31,82.962860,83.071426,81.637146,82.532860,71.448456,122918600
2012-06-01,81.308571,81.807144,80.074287,80.141426,69.378235,130246900
2012-06-04,80.214287,81.071426,78.357140,80.612854,69.786331,139248900
2012-06-05,80.181427,80.924286,79.761429,80.404289,69.605789,97053600
2012-06-06,81.110001,81.978569,80.785713,81.637146,70.673080,100363900
2012-06-07,82.470001,82.474289,81.500000,81.674286,70.705200,94941700
2012-06-08,81.657143,82.940002,81.285713,82.902855,71.768784,86879100
2012-06-11,83.959999,84.071426,81.518570,81.595711,70.637215,147816200
2012-06-12,82.065712,82.374283,80.957146,82.308571,71.254295,108845100
2012-06-13,82.074287,82.639999,81.482857,81.737144,70.759613,73395000
2012-06-14,81.605713,81.928574,81.037140,81.647141,70.681709,86393300
2012-06-15,81.571426,82.088570,81.364288,82.018570,71.003258,83813800
2012-06-18,81.565712,83.984283,81.481430,83.682854,72.444016,110103000
2012-06-19,83.342857,84.285713,83.300003,83.915718,72.645630,90351100
2012-06-20,84.029999,84.178574,82.971428,83.677139,72.439079,89735800
2012-06-21,83.634285,84.031425,82.491432,82.524284,71.441055,81587800
2012-06-22,82.720001,83.169998,82.202858,83.157143,71.988930,71117900
2012-06-25,82.471428,82.828575,81.481430,81.538574,70.587730,76095600
2012-06-26,81.618568,82.070000,81.047142,81.718575,70.743546,69134100
2012-06-27,82.142860,82.391426,81.702858,82.071426,71.049019,50749300
2012-06-28,81.667145,82.000000,80.801430,81.292854,70.375008,70709100
2012-06-29,82.571426,83.428574,82.035713,83.428574,72.223900,105375200
2012-07-02,83.532860,84.781425,83.371429,84.645714,73.277565,100023000
2012-07-03,84.982857,85.714287,84.857140,85.629997,74.129662,60428200
2012-07-05,85.794289,87.762856,85.664284,87.134285,75.431908,121095800
2012-07-06,86.727142,86.919998,85.940002,86.554283,74.929825,104732600
2012-07-09,86.471428,87.699997,86.301430,87.698570,75.920433,94851400
2012-07-10,88.281425,88.552856,86.472855,86.887146,75.217979,127989400
2012-07-11,86.588570,86.808571,85.317146,86.347145,74.750511,117330500
2012-07-12,85.748573,86.209999,84.668571,85.557144,74.066574,107010400
2012-07-13,86.135712,86.741432,85.714287,86.424286,74.817261,77856800
2012-07-16,86.445717,87.374283,86.431427,86.701431,75.057205,75315100
2012-07-17,87.255714,87.357140,86.164284,86.705711,75.060905,73406200
2012-07-18,86.655716,86.905716,86.222855,86.608574,74.976830,63175000
2012-07-19,87.325714,87.907143,86.571426,87.760002,75.973618,109215400
2012-07-20,87.575714,87.777145,86.242859,86.328575,74.734436,99367800
2012-07-23,84.914284,86.557144,83.958572,86.261429,74.676285,121993900
2012-07-24,86.768570,87.097145,85.501427,85.845711,74.316422,141283100
2012-07-25,82.065712,82.971428,81.428574,82.138573,71.107155,219328200
2012-07-26,82.822861,82.914284,81.480003,82.125717,71.096016,101658200
2012-07-27,82.144287,83.690002,81.655716,83.594284,72.367340,100984100
2012-07-30,84.417145,85.634285,83.974289,85.004288,73.588005,94785600
2012-07-31,86.175713,87.385712,86.102859,87.251427,75.533325,115581900
2012-08-01,87.987144,88.057144,86.142860,86.687141,75.044838,96125400
2012-08-02,86.120003,87.241432,85.750000,86.827141,75.166046,83039600
2012-08-03,87.661430,88.282860,87.365715,87.957146,76.144272,86230200
2012-08-06,88.184288,89.267143,87.894287,88.935715,76.991409,75525800
2012-08-07,88.967140,89.285713,88.291428,88.701431,76.788589,72611700
2012-08-08,88.484283,89.125717,88.157143,88.551430,76.658752,61176500
2012-08-09,88.264282,88.818573,88.257141,88.675713,77.095924,55410600
2012-08-10,88.387146,88.822861,88.385712,88.814285,77.216408,48734700
2012-08-13,89.055717,90.000000,89.035713,90.000000,78.247292,69708100
2012-08-14,90.267143,91.230003,90.029999,90.241432,78.457176,85042300
2012-08-15,90.185715,90.571426,89.678574,90.118568,78.350349,64335600
2012-08-16,90.172859,90.965714,90.071426,90.905716,79.034737,63633500
2012-08-17,91.428574,92.598572,91.258568,92.587143,80.496590,110690300
2012-08-20,92.858574,95.021431,92.842857,95.021431,82.612991,153346200
2012-08-21,95.831429,96.411430,92.904289,93.722855,81.483978,203179900
2012-08-22,93.488571,95.571426,92.587143,95.552856,83.075020,141330700
2012-08-23,95.158569,95.699997,94.449997,94.661430,82.299995,105032200
2012-08-24,94.215714,95.639999,93.650002,94.745712,82.373276,109335100
2012-08-27,97.141426,97.267143,96.220001,96.525711,83.920822,106752100
2012-08-28,96.425713,96.585716,95.809998,96.400002,83.811516,66854200
2012-08-29,96.464287,96.809998,96.085716,96.209999,83.646347,50701700
2012-08-30,95.805717,95.935715,94.692856,94.838570,82.454002,75674900
2012-08-31,95.321426,95.514282,93.892860,95.034286,82.624168,84580300
2012-09-04,95.108574,96.448570,94.928574,96.424286,83.832657,91973000
2012-09-05,96.510002,96.621429,95.657143,95.747147,83.243935,84093800
2012-09-06,96.167145,96.898575,95.828575,96.610001,83.994133,97799100
2012-09-07,96.864288,97.497147,96.538574,97.205711,84.512062,82416600
2012-09-10,97.207146,97.612854,94.585716,94.677139,82.313660,121999500
2012-09-11,95.015717,95.728569,93.785713,94.370003,82.046638,125995800
2012-09-12,95.264282,95.699997,93.714287,95.684288,83.189293,178058300
2012-09-13,96.767143,97.928574,96.395714,97.568573,84.827507,149590000
2012-09-14,98.565712,99.568573,98.269997,98.754288,85.858398,150118500
2012-09-17,99.907143,99.971428,99.230003,99.968575,86.914085,99507800
2012-09-18,99.982857,100.332855,99.488571,100.272858,87.178650,93375800
2012-09-19,100.037140,100.570000,99.938568,100.300003,87.202278,81718700
2012-09-20,99.879997,100.008568,99.088570,99.814285,86.779953,84142100
2012-09-21,100.344284,100.724289,99.908569,100.012856,86.952637,142897300
2012-09-24,98.122856,99.302856,97.571426,98.684288,85.797539,159941600
2012-09-25,98.322861,98.968575,96.142860,96.220001,83.655052,129697400
2012-09-26,95.534286,96.098572,94.457146,95.025711,82.616745,144125800
2012-09-27,94.898575,97.452858,94.335716,97.331429,84.621330,148522500
2012-09-28,96.964287,97.301430,95.250000,95.300003,82.855186,133777700
2012-10-01,95.879997,96.678574,93.785713,94.198570,81.897568,135898700
2012-10-02,94.544289,95.192856,92.949997,94.472855,82.136055,156998100
2012-10-03,94.980003,95.980003,94.661430,95.921425,83.395477,106070300
2012-10-04,95.892860,96.321426,95.078575,95.257141,82.817886,92681400
2012-10-05,95.028572,95.142860,93.040001,93.227142,81.053017,148501500
2012-10-08,92.411430,92.508568,90.872856,91.167145,79.262016,159498500
2012-10-09,91.235718,91.498573,89.078575,90.835716,78.973854,209649300
2012-10-10,91.391426,92.139999,91.000000,91.558571,79.602348,127589000
2012-10-11,92.357140,92.457146,89.728569,89.728569,78.011299,136520300
2012-10-12,89.937141,90.768570,89.328575,89.958572,78.211266,115003700
2012-10-15,90.335716,90.732857,89.121429,90.680000,78.838493,108125500
2012-10-16,90.767143,92.900002,90.142860,92.827141,80.705238,137442900
2012-10-17,92.695717,93.255714,92.000000,92.087143,80.061859,97259400
2012-10-18,91.370003,91.722855,90.000000,90.377144,78.575172,119156100
2012-10-19,90.150002,90.252853,87.088570,87.120003,75.743378,186021500
2012-10-22,87.488571,90.768570,87.251427,90.575714,78.747810,136682700
2012-10-23,90.142860,90.557144,87.385712,87.622856,76.180557,176786400
2012-10-24,88.777145,89.507141,87.234283,88.118568,76.611557,139631800
2012-10-25,88.571426,88.857140,86.507141,87.077141,75.706116,164081400
2012-10-26,87.061432,87.714287,84.428574,86.285713,75.018044,254608200
2012-10-31,84.982857,85.994286,83.957146,85.045715,73.939964,127500800
2012-11-01,85.459999,86.142860,84.881432,85.220001,74.091492,90324500
2012-11-02,85.127144,85.278572,82.107140,82.400002,71.639740,149843400
2012-11-05,83.360001,83.967140,82.514282,83.517143,72.611008,132283900
2012-11-06,84.318573,84.391426,82.870003,83.264282,72.391151,93729300
2012-11-07,81.977142,82.077141,79.392860,79.714287,69.621292,198412200
2012-11-08,80.089996,80.318573,76.470001,76.821426,67.094681,264036500
2012-11-09,77.202858,79.268570,76.245712,78.151428,68.256302,232478400
2012-11-12,79.164284,79.214287,76.949997,77.547142,67.728531,128950500
2012-11-13,76.987144,78.639999,76.622856,77.557144,67.737251,133237300
2012-11-14,77.928574,78.207146,76.597145,76.697144,66.986145,119292600
2012-11-15,76.790001,77.071426,74.660004,75.088570,65.581261,197477700
2012-11-16,75.028572,75.714287,72.250000,75.382858,65.838257,316723400
2012-11-19,77.244286,81.071426,77.125717,80.818573,70.585739,205829400
2012-11-20,81.701431,81.707146,79.225716,80.129997,69.984367,160688500
2012-11-21,80.607140,81.052856,79.514282,80.242859,70.082916,93250500
2012-11-23,81.024284,81.714287,80.371429,81.642860,71.305679,68206600
2012-11-26,82.271431,84.285713,81.958572,84.218575,73.555260,157644900
2012-11-27,84.221428,84.345711,82.871429,83.540001,72.962601,133332500
2012-11-28,82.467140,83.685715,81.751427,83.277145,72.733009,130216100
2012-11-29,84.317146,84.892860,83.607140,84.194283,73.534042,128674700
2012-11-30,83.827141,84.057144,83.239998,83.611427,73.024994,97829900
2012-12-03,84.807144,84.941429,83.642860,83.741432,73.138519,91070000
2012-12-04,83.114288,83.114288,81.732857,82.264282,71.848396,139267100
2012-12-05,81.272858,81.321426,76.967140,76.970001,67.224457,261159500
2012-12-06,75.562859,79.044289,74.089996,78.177139,68.278755,294303100
2012-12-07,79.057144,79.314285,75.714287,76.178574,66.533249,196760200
2012-12-10,75.000000,76.930000,74.511429,75.688568,66.105286,157621100
2012-12-11,77.110001,78.508568,76.767143,77.341431,67.548859,148086400
2012-12-12,78.252853,78.285713,76.610001,77.000000,67.250648,121786000
2012-12-13,75.878571,76.805717,75.114288,75.669998,66.089035,156314900
2012-12-14,73.535713,74.018570,72.225716,72.827141,63.606129,252394800
2012-12-17,72.704285,74.285713,71.604286,74.118568,64.734062,189401800
2012-12-18,75.000000,76.414284,74.321426,76.271431,66.614326,156421300
2012-12-19,75.924286,76.242859,75.071426,75.187141,65.667343,112342300
2012-12-20,75.714287,75.742859,74.125717,74.532860,65.095894,120422400
2012-12-21,73.209999,74.238571,72.891426,74.190002,64.796455,149067100
2012-12-24,74.335716,74.892860,74.101425,74.309998,64.901253,43938300
2012-12-26,74.142860,74.208572,73.017143,73.285713,64.006668,75609100
2012-12-27,73.362854,73.750000,72.094284,73.580002,64.263687,113780100
2012-12-28,72.898575,73.497147,72.588570,72.798569,63.581192,88569600`;

export default actionsCsv;
